import {
  Component,
  OnDestroy,
  OnInit,
  ElementRef,
  AfterContentInit,
  ViewChild,
  TemplateRef
} from '@angular/core';
import {
  ProcurementProjectDTO,
  ProcurementProjectLotDTO,
  CompanyToInviteDTO,
  AwardDTO,
  RequestMaterialDTO,
  CriteriaDTO,
  ResultTypeDTO,
  ValidationResultDTO,
  ValidationResultDTOError,
  CompanyDTO,
  ObjectContextDTO,
  ActionResultDTO,
  getResultTypeDTOLevel,
  SpecialExecutionConditionDTO,
  SocClausesAwardCritDTO,
  PriceRevisionDTO,
  UnitPriceDTO,
  ActionDefinitionDTO,
} from '../../api/plyca-dtos-v2';
import { ActionDTO, ProcurementProjectDefinitionsDTO, ProcurementProjectStepsDefinitionDTO, ProcurementProjectStepDTO, MasterDataDTO, DocumentDTO, WorkDTO }
  from '../../api/plyca-dtos';
import { UserService } from '../../user.service';
import { FormConfig, FormGroupConfig, TemplateDef } from '../../components/forms/form.objects';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';
import { searchCPVComponent } from '../../components/searchCPV/searchCPV.component';
import { ProcurementProjectAYMADValidations } from './procurementProjectAYMAD.validation';
import {
  FieldConfig
} from '../../api/contract-notice-dto';
import { PaginationDTO } from '../../api/PaginationModel';
import { SearchLotsAwardsPopupAYMADComponent } from './searchLotsAwardsPopupAYMAD.component';
import { BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';

import * as lodash from 'lodash';
import { generateRandomIdentifier } from '../../ui.service';
import { map, switchMap, catchError, finalize, tap, take, skipWhile } from 'rxjs/operators';
import { TaskHandler } from '../../tasks/TaskHandler';
import { EMPTY, forkJoin, Observable, of, throwError } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { PropertyService } from '../../properties/property.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { DossierModelsService } from '../../dossiers/dossierModels/DossierModels.service';
import { formElementComponent } from '../../components/forms/formElement.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { ActivatedRoute } from '@angular/router';
import { TemplateService } from '../../documents/template/template.service';
import { ProcurementProjectAYMADCBAMValidations } from './procurementProjectCBAM_AYMAD.validation';
import { ProcurementProjectAYMADCSDAValidations } from './procurementProjectCSDA_AYMAD.validation';
import { ProcurementProjectAYMADAMValidations } from './procurementProjectAM_AYMAD.validation';
import { environment } from '../../../environments/environment';
import { UnitPricesListComponent } from '../../dossiers/unitPrices/UnitPricesList.component';

// import { isInteger } from 'lodash';

import { MenuItem } from 'primeng-lts/api';
import { PartialCopyOptions, ProcurementProjectAYMADUtils } from './procurementProjectAYMAD.utils';
import { empty } from 'objectPath';
import { FormService } from '../../components/forms/form.service';
import { Data } from 'popper.js';
import { reject } from 'lodash';
import { Refresh } from '@ngrx/store-devtools/src/actions';
import { LongTextDTOModal, LongTextEditorComponent } from '../../components/forms/longTextEditor.component';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { ProjectEntityDTO } from '../../api/plyca-dtos-v2';
import { ProjectDefaultFieldDTO } from '../../api/plyca-dtos';
import {
  MasterData
} from '../../api/contract-notice-dto';
import { mergeMap } from 'rxjs/operators';
import { ProfileService } from '../../../services/profile.services';
import { ServiceLocator } from './../../ServiceLocator';
import { ProcurementProjectAYMADMINORValidations } from './procurementProjectMINOR_AYMAD.validation';
//import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
//import { Router } from '@angular/router';


const LOT_EXPANSION = 'expansionSet:web_fe';
const PROJECT_EXPANSION_ONESTEP = 'expansionSet:web_fe_onestep';
const PROJECT_EXPANSION_TWOSTEPS = 'expansionSet:web_fe_twosteps';
const XML_UPDATE_EXPANSION = 'fichProcurementProject,fichProcurementProject.document,fichProcurementProject.document.refreshSystemFiles';

@Component({
  selector: 'procurementProjectAYMAD',
  templateUrl: 'procurementProjectAYMAD.template.html',
  providers: [ProcurementProjectAYMADValidations, ProcurementProjectAYMADCBAMValidations, ProcurementProjectAYMADCSDAValidations, ProcurementProjectAYMADAMValidations, ProcurementProjectAYMADUtils, ProcurementProjectAYMADMINORValidations]
})
export class procurementProjectAYMADComponent extends TaskHandler
  implements OnInit, OnDestroy, AfterContentInit {

  // Variable que indica si se está en la pantalla previa para seleccionar la configuracion a utilizar
  // Configuracion de la ficha a utilizar
  public stepDefinition: ProcurementProjectStepsDefinitionDTO;
  // Paso de la Ficha en el que nos encontramos
  public currentStep = 0;
  public formConfig: FormConfig;

  private loaded = false;
  // procesandoTarea = false;

  // INFORMACION DEL EXPEDIENTE
  private dossierId: string;
  public dossier: ProcurementProjectDTO;

  // nombre de plantilla para el caso de resumen de lotes (AM con lotes)º
  private nameTemplateVG: string;

  // INFORMACION DEL LOTE DESGLOSADO
  private lot: ProcurementProjectLotDTO;
  private formid: any;
  // private TRAMITACIONOK = false;
  private isNewDossier = false;

  private harmonizedRegulationAttributeAYMAD: string;

  private salirConAviso = true;

  public showGoToLotSelection = false;
  // Propiedades copia parcial
  public showPartialLotCopy = false;
  public lotsToCopy: Array<ProcurementProjectLotDTO>;
  public selectedLotToCopy: ProcurementProjectLotDTO;
  public selectedCopyOptions: PartialCopyOptions[];
  // transformar enumerado a lista
  public copyLotOptions = Object.values(PartialCopyOptions) as PartialCopyOptions[];
  // Fin propiedades copia parcial

  public showDetailFormRevPrice = false;

  public saveAlways = undefined;

  public lotMenuItems: MenuItem[];

  isBasedContract = false;
  frameworkAgreementParent: string;
  contractDivisionFrameworkAgreement: string;

  isSpecificContract = false;
  dynamicPurchasingSystemParent: string;
  categorySelectedSDA: string;
  cpvSelectedSDA: string;

  // Atributos y variables globales, para poder refactorizar y meterlos como propiedad de otro objeto
  private date_Expte_Instruc_1_16: Date;

  // Propiedades que se utilizan para la Apariencia y validaciones
  private properties = {};

  // variable para actualizar la información del expediente tras cambio en lote
  private lotModified: boolean;

  // Si viene desde una tarea pasa del readOnly siempre es false
  private readonly = false;

  // templates
  @ViewChild('budgetSummaryTemplate')
  budgetSummaryTemplate: TemplateRef<any>;

  @ViewChild('budgetSummaryAMTemplate')
  budgetSummaryAMTemplate: TemplateRef<any>;

  private profileService: any;


  protected correctoPaso1 = true;



  constructor(
    private configuration: Configuration,
    private propertyService: PropertyService,
    public userService: UserService,
    public dossierModelService: DossierModelsService,
    public formService: FormService,
    public helpService: HelpService,
    public activatedRoute: ActivatedRoute,
    private procurementProjectValidations: ProcurementProjectAYMADValidations,
    private procurementProjectValidationscbam: ProcurementProjectAYMADCBAMValidations,
    private procurementProjectValidationscsda: ProcurementProjectAYMADCSDAValidations,
    private procurementProjectValidationsMinor: ProcurementProjectAYMADMINORValidations,
    private procurementProjectValidationsAM: ProcurementProjectAYMADAMValidations,
    private procurementProjectAYMADUtils: ProcurementProjectAYMADUtils,
    private headerActionsService: HeaderActionsService,
    private plycaErrorHandler: PlycaErrorHandler,
    public templateService: TemplateService,
    // private router: Router,
    private elem: ElementRef
  ) {
    super();
    this.profileService = ServiceLocator.injector.get(ProfileService);
  }

  ngOnInit(): void {
    this.subscribe(
      this.helpService.showContextHelpObservable(HelpType.TIPO_FICHA));

    //la plantilla de resumen de lotes disponible para AM con lotes se carga desde una propiedad
    this.subscribe(this.propertyService.getProperty('PLANTILLA_VISION_GLOBAL'), (value: string) => { this.nameTemplateVG = value; });

    if (this.task) {
      console.log('INVOCACIONA PROCUREMENTPROJECT DESDE TAREA', this.task);
      this.dossierId = this.task.division.project.identifier;
      console.log('Entrando a editar project', this.dossierId);
      this.subscribe(this.loadStepsDefinition());
    } else {
      // Sino viene desde Tarea, se trata el modo solo lectura
      this.subscribe(forkJoin([
        this.activatedRoute.params.pipe(
          take(1),
          tap(params => {
            this.dossierId = params['id'];

            console.log('INVOCACIONA PROCUREMENTPROJECT DESDE url', params['id']);
          }),

          mergeMap(() => this.isUserCanViewFE(this.dossierId, undefined)),
          tap((readOnly_: boolean) => {
            this.readonly = readOnly_;
          })
        ),
        this.activatedRoute.queryParams.pipe(
          take(1),
          tap(queryParams => {


            if (queryParams['isBasedContract'] !== undefined && queryParams['isBasedContract'] === 'true') {
              this.isBasedContract = true;
            } else if (queryParams['isSpecificContract'] !== undefined && queryParams['isSpecificContract'] === 'true') {
              this.isSpecificContract = true;
            }
            if (this.isBasedContract) {
              if (queryParams['frameworkAgreementParent'] !== undefined) {
                this.frameworkAgreementParent = queryParams['frameworkAgreementParent'];
              }
              if (queryParams['contractDivisionFrameworkAgreement'] !== undefined) {
                this.contractDivisionFrameworkAgreement = queryParams['contractDivisionFrameworkAgreement'];
              }
            } else if (this.isSpecificContract) {
              if (queryParams['dynamicPurchasingSystemParent'] !== undefined) {
                this.dynamicPurchasingSystemParent = queryParams['dynamicPurchasingSystemParent'];
              }
              if (queryParams['categorySelectedSDA'] !== undefined) {
                this.categorySelectedSDA = queryParams['categorySelectedSDA'];
              }
              if (queryParams['cpvSelectedSDA'] !== undefined) {
                this.cpvSelectedSDA = queryParams['cpvSelectedSDA'];
              }
            }
            /*if (queryParams['readonly'] !== undefined && queryParams['readonly'] === "true") {
              this.readonly = true;
            }*/
            this.formid = queryParams['formid'];
          })
        )
      ]).pipe(
        switchMap(() => this.loadStepsDefinition())
      ));
    }
  }

  // Este metodo es el que establece el readOnly
  public isUserCanViewFE(identifier: string, phaseId: string): Observable<boolean> {
    if (identifier !== undefined && identifier !== null) {
      return this.activatedRoute.queryParams.pipe(
        take(1),
        tap(queryParams => {
          // Independientemente del valor que tenga, viene de la gestión de Expedientes, de la opción Visualizar
          if (queryParams['readonly'] !== undefined) {
            this.readonly = true;
          }
        }),
        mergeMap(() => this.profileService.isUserCanPrepareProject(identifier, undefined)),
        tap((can) => {
          if (!this.readonly) {
            can = identifier === undefined || can;
            this.readonly = !can; // Aquí actualizamos la variable 'readonly' según la condición
          }
        }),
        switchMap(() => {
          return this.plycaService.getProcurementProject(this.dossierId).pipe(
            switchMap(result => {
              console.log('resultado de getProcurementProject');
              // SI NO TIENE IDFORMULARIO, NO SE PUEDE VISUALIZAR EL EXPEDIENTE
              if (!result.formId) {
                this.readonly = true;
                this.route.navigate(['errorVisualizacion']).then(success => {
                  console.log('Navegación exitosa:', success);
                }).catch(error => {
                  console.error('Error en navigate:', error);
                });
              }
              // Devolvemos un observable con el valor de 'readonly'
              return of(this.readonly);
            })
          );
        })
      );
    } else {
      // Sino tiene identificador hay que editar
      return of(false);
    }
  }

  ngAfterContentInit(): void {
    this.setHeader();
  }

  ngOnDestroy(): void {
    this.formPlycaRef = undefined;
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  private setHeader(txt?: string) {
    this.headerActionsService.setTaskDescription(
      this.elem,
      txt
        ? txt
        : txt,
      (this.lot || this.dossierId) ? 'fas fa-pen' : 'fas fa-plus',
      true
    );
    this.headerActionsService.setShowDocumentsVisible(true);
  }



  generaTemplateMJCM(): void {
    this.formPlycaRef.markAsDirty();
    this.formPlycaRef.updateView();
    this.uiService.showConfirmMessage({
      message: 'Para visualizar la "Memoria Justificativa del Contrato Menor" se grabarán automáticamente los datos introducidos en la Ficha de Expediente. ¿Desea continuar con la operación?',
      header: this.translateService.instant('General.confirmtext'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.waitService.startWaiting(this.translateService.instant('GenericDossier.changing'));
        this.subscribe(this.saveProjectIfNecessary(XML_UPDATE_EXPANSION).pipe(
          switchMap(() => {
            this.waitService.startWaiting('Generando previsualización...');
            return this.templateService.
              generaTemplateByDocumentClassName(this.dossier.identifier, 'MJCM', '0').pipe(
                catchError((error: any) => {
                  this.plycaErrorHandler.showServerError(error);
                  return throwError(error);
                }),
              )
          }),
          finalize(() => {
            this.waitService.cancelWaiting();
            this.loaded = true;
          }))
        );
      },
      reject: () => {
        console.log('NO SE CARGAN LOS CRITERIOS');
      }
    });
  }

  generaTemplateGlobalVision(model: any): void {
    this.formPlycaRef.markAsDirty();
    this.formPlycaRef.updateView();

    if (this.readonly) {
      this.templateService.generaTemplateByName(this.nameTemplateVG, this.dossier.identifier, '0', 'VISION_GLOBAL').pipe(
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })
      ).subscribe();
    } else {
      this.uiService.showConfirmMessage({
        message: 'Para visualizar el RESUMEN de información asociado a los LOTES se grabarán automáticamente los datos introducidos en la Ficha de Expediente. ¿Desea continuar con la operación?',
        header: this.translateService.instant('General.confirmtext'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.waitService.startWaiting(this.translateService.instant('GenericDossier.changing'));
          this.subscribe(this.saveProjectIfNecessary(XML_UPDATE_EXPANSION).pipe(
            switchMap(() => {
              this.waitService.startWaiting('Generando previsualización...');
              return this.templateService.generaTemplateByName(this.nameTemplateVG, this.dossier.identifier, '0', 'VISION_GLOBAL').pipe(
                catchError((error: any) => {
                  this.plycaErrorHandler.showServerError(error);
                  return throwError(error);
                })
              );
            }),
            finalize(() => {
              this.waitService.cancelWaiting();
              this.loaded = true;
            })
          ));
        },
        reject: () => {
          console.log('NO SE CARGAN LOS CRITERIOS');
        }
      });
    }
  }

  isButtonTemplateMJCMVisible(): boolean {
    return this.dossier?.type?.identifier === 'M<>PROCEDIMIENTOSCONTRA';
  }

  isButtonTemplateGlobalVisionVisible(): boolean {
    // Si está desglodado en lotes y tiene lotes en la tabla de lotes
    // return (this.dossier?.breakdownLot?.apportioned &&
    // this.dossier?.classification?.complementarySystem?.identifier == 'AM<>SISTCOMPLEMENTARIO');

    return (this.dossier &&
      this.dossier?.breakdownLot?.apportioned &&
      this.dossier.breakdownLot &&
      this.dossier.breakdownLot.lots &&
      this.dossier.breakdownLot.lots.length > 0);
  }

  /*isButtonVisibleDocProcurementProject(): boolean {
    return (this.dossier != null);
  }*/

  public isVisibleUnitPrice() {
    let isFrameworkAgreement = false;
    if (this.dossier?.classification?.complementarySystem?.identifier) {
      isFrameworkAgreement = this.dossier.classification.complementarySystem.identifier == 'AM<>SISTCOMPLEMENTARIO';
    }
    let tipoExpte = (this.dossier?.classification?.typeCode && this.dossier?.classification?.typeCode?.identifier) ?
      this.dossier?.classification?.typeCode.identifier : undefined;
    let isWorks = tipoExpte !== undefined && this.dossier?.classification.typeCode.identifier === '01<>TIPOEXPTE';
    let existsUnitPrices = false;
    if (this.dossier?.breakdownLot && this.dossier?.breakdownLot.lots && this.dossier?.breakdownLot.lots.length > 0) {
      for (let lot of this.dossier?.breakdownLot.lots) {
        if (lot?.budget?.unitPrice !== undefined) {
          existsUnitPrices = true;
          break;
        }
      }
    }
    return (isFrameworkAgreement || (!isFrameworkAgreement && (!isWorks))) && existsUnitPrices;
  }

  public isVisibleButtonUnitPrice(dossier: ProcurementProjectDTO, lot: ProcurementProjectLotDTO) {
    // Si es AM se ve siempre
    let isFrameworkAgreement = false;
    let isCSDA = false;

    if (dossier?.classification?.complementarySystem?.identifier) {
      isFrameworkAgreement = dossier.classification.complementarySystem.identifier == 'AM<>SISTCOMPLEMENTARIO';
      isCSDA = dossier.classification.complementarySystem.identifier == 'CSDA<>SISTCOMPLEMENTARIO';
    }


    // Si es Contratacion se ve siempre que sea distinto de obras
    let typeCode = (dossier?.classification?.typeCode && dossier?.classification?.typeCode?.identifier) ?
      dossier?.classification?.typeCode.identifier : undefined;

    let isServices = typeCode !== undefined && dossier?.classification.typeCode.identifier === '04<>TIPOEXPTE';
    let isGoods = typeCode !== undefined && dossier?.classification.typeCode.identifier === '02<>TIPOEXPTE';
    let isGoodsVisible = isGoods && lot?.budget?.budgetDetermination;

    // Si es un CSDA, no se tiene en cuenta el sistema de determinación del presupuesto
    return ((isFrameworkAgreement && !dossier.budget?.withoutUnitPrice) || isCSDA || (!isFrameworkAgreement && !isCSDA && (isServices || isGoodsVisible)));
  }

  public isVisibleButtonLoadUnitPriceAmount(dossier: ProcurementProjectDTO, lot: ProcurementProjectLotDTO) {
    // Si es AM no se ve nunca el botón  de Volcar Importes a Precios Unitarios
    let isFrameworkAgreement = false;
    let isCSDA = false;

    if (dossier?.classification?.complementarySystem?.identifier) {
      isFrameworkAgreement = dossier.classification.complementarySystem.identifier == 'AM<>SISTCOMPLEMENTARIO';
      isCSDA = dossier.classification.complementarySystem.identifier == 'CSDA<>SISTCOMPLEMENTARIO';
      if (isFrameworkAgreement) {
        return false;
      }
    }

    // Si es Contratacion se ve siempre que sea distinto de obras
    let typeCode = (dossier?.classification?.typeCode && dossier?.classification?.typeCode?.identifier) ?
      dossier?.classification?.typeCode.identifier : undefined;

    let isServices = typeCode !== undefined && dossier?.classification.typeCode.identifier === '04<>TIPOEXPTE';
    let isGoods = typeCode !== undefined && dossier?.classification.typeCode.identifier === '02<>TIPOEXPTE';
    let isGoodsVisible = isGoods && lot?.budget?.budgetDetermination;


    return (isCSDA || (!isFrameworkAgreement && !isCSDA && (isServices || isGoodsVisible)));
  }


  public isVisibleButtonUnitPriceCSDA(dossier: ProcurementProjectDTO) {
    let isCSDA = false;
    if (dossier?.classification?.complementarySystem?.identifier) {
      isCSDA = dossier.classification.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO';
    }
    return isCSDA;
  }

  public isApportioned() {
    return this.dossier?.breakdownLot?.apportioned;
  }

  public setActionButtons() {
    this.waitService.startWaiting();
    this.headerActionsService.clearActions();
    this.headerActionsService.addDivider();
    this.headerActionsService.addDivider();
    this.headerActionsService.addDivider();
    // visualizar plantilla MJCM
    if (!this.readonly) {
      this.subscribe(this.headerActionsService
        .addActionWithType(
          'Previsualizar Memoria Menor',
          'fas fa-lg fa-file',
          'btn btn-secondary btn-sm ng-star-inserted',
          'submit',
          () => this.isButtonTemplateMJCMVisible()
        ), () => this.generaTemplateMJCM()
      );
    }

    /*// Ver Expediente
    this.subscribe(this.headerActionsService
      .addActionWithType(
        'Ver Expediente',
        'fas fa-lg fa-file',
        'btn btn-secondary btn-sm ng-star-inserted',
        'submit',
        true
        //() => this.isButtonVisibleDocProcurementProject()
      ), () => this.openDocument(this.dossier)
    );*/


    // visualizar plantilla Ver Resumen de Lotes
    this.subscribe(this.headerActionsService
      .addActionWithType(
        'Ver Resumen Lotes',
        'fas fa-lg fa-file',
        'btn btn-secondary btn-sm ng-star-inserted',
        'submit',
        () => !this.hasPreviousStep() && this.isButtonTemplateGlobalVisionVisible()
      ), () => this.generaTemplateGlobalVision(this)
    );


    // Visualizar Precios Unitarios (Paso 2)
    this.subscribe(this.headerActionsService
      .addAction(
        'Precios unitarios',
        undefined,
        'btn-secondary',
        () => this.hasPreviousStep() && this.isVisibleButtonUnitPrice(this.dossier, this.lot)
      ),
      () => {
        this.openUnitPricesEditor(this.lot)
      });

    if (!this.readonly) {

      // Volcado Importes Precios Unitarios Contratacion/ AM no hay importes
      this.subscribe(this.headerActionsService
        .addAction(
          'Volcado Importe P. Unitarios',
          undefined,
          'btn-secondary',
          () => this.hasPreviousStep() && this.isVisibleButtonLoadUnitPriceAmount(this.dossier, this.lot)
        ),
        () => {
          this.calculateBudgetsUnitPrice(this.lot)
        });
    }

    // Visualizar Precios Unitarios CSDA (Paso 1)
    this.subscribe(this.headerActionsService
      .addAction(
        'Precios unitarios',
        undefined,
        'btn-secondary',
        () => this.isVisibleButtonUnitPriceCSDA(this.dossier)
      ),
      () => {
        this.confirmOpenUnitPricesEditorCSDA()
      });



    if (!this.readonly) {

      // Volcado Importes Precios Unitarios CSDA
      this.subscribe(this.headerActionsService
        .addAction(
          'Volcado Importe P. Unitarios',
          undefined,
          'btn-secondary',
          () => this.isVisibleButtonUnitPriceCSDA(this.dossier)
        ),
        () => {
          this.calculateBudgetsUnitPriceCSDA(this.dossier)
        });
    }



    // Ir a Lote
    this.subscribe(this.headerActionsService
      .addAction(
        'Ir al Lote',
        'fas fa-lg fa-list-ol',
        'btn-secondary',
        () => this.isApportioned() && this.hasPreviousStep()
      ), () => {
        this.lotMenuItems = this.getLotMenuItems();
        this.showGoToLotSelection = true;
      }
    );

    if (!this.readonly) {
      // Copia parcial de lote
      this.subscribe(this.headerActionsService
        .addAction(
          'Copiar Datos',
          'fas fa-lg fa-clone',
          'btn-secondary',
          () => true && this.isApportioned() && this.hasPreviousStep()
        ), () => this.showpartialCopyOptions()
      );

      // Verificar (solo compilacion desarrollo)
      this.subscribe(this.headerActionsService
        .addAction(
          'Verificar',
          'fas fa-lg fas fa-check',
          'btn-secondary',
          () => this.dossier && !this.lot && !environment.production
        ), () => this.verifyDossier()
      );

      // Guardar
      this.subscribe(this.headerActionsService
        .addActionWithType(
          'General.save',
          'fas fa-lg fa-save',
          'btn-primary',
          'submit',
          true
        ),
        () => this.save()
      );


      // Aceptar (tengo lotes y estoy en paso 1) o (no tengo lotes y (estoy en el paso 2 o no hay 2 paso))
      this.subscribe(this.headerActionsService
        .addActionWithType(
          'General.accept',
          'fas fa-check',
          'btn-primary',
          'submit',
          () => this.loaded && (this.isApportioned() && this.isStep1())
            || (!this.isApportioned() && (this.isStep2() || !this.hasNextStep()))
        ),
        () => this.accept()
      );
    }

    // Ir al Paso 1
    this.subscribe(this.headerActionsService
      .addAction(
        'ProcurementProjectAYMAD.previous',
        'fas fa-lg fa-backward',
        'btn-primary',
        () => this.loaded && !this.isApportioned() && this.hasPreviousStep()
      ),
      () => this.cancelLotEdition(true) //Tiene que grabar los cambios para volver al paso 1 (sin lotes)
    );

    // Ir al Paso 2
    this.subscribe(this.headerActionsService
      .addAction(
        'ProcurementProjectAYMAD.next',
        'fas fa-lg fa-forward',
        'btn-primary',
        () => this.loaded && !this.isApportioned() && this.hasNextStep()
      ), () => this.nextStep()
    );



    // Exportar precios unitarios
    if (!this.readonly) {
      /*this.subscribe(this.headerActionsService
        .addAction(
          'Exportar Precios Unitarios',
          'far fa-file-excel',
          'btn-primary',
          () => this.loaded && this.isApportioned() && this.hasNextStep() && this.isVisibleUnitPrice()
        ), () => this.exporAlltUnitPrice()
      );*/


      // Cancelar
      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService
        .addAction(
          'General.cancel',
          'fas fa-1-25x fa-times',
          'btn-outline-secondary',
          //() => !this.isApportioned()
          () => true,
        ), () => this.cancel(false)
      );
    }

    // Volver desde edicion de lote
    this.subscribe(this.headerActionsService
      .addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        () => this.isApportioned() && this.lot !== undefined
      ), () => {
        let dirty = this.formPlycaRef?.formGroup?.dirty;
        if (dirty) {
          // Solicitar confirmación si hay cambios pendientes
          this.uiService.showConfirmMessage({
            message: 'Se han realizado cambios en la pantalla. ¿Está seguro que desea continuar y descartar estos cambios?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              this.cancelLotEdition();
            }
          });
        } else {
          this.cancelLotEdition();
        }
      }
    );

    // Boton de Salir, para solo lectura
    if (this.readonly) {
      this.subscribe(this.headerActionsService
        .addAction(
          'GenericDossier.exit',
          'fas fa-1-25x fa-times',
          'btn-outline-secondary',
          true
        ), () => this.exit(false)
      );
    }
  }

  private save() {
    this.subscribe(this.saveObservable())
  }

  private saveObservable(cancelWait = true): Observable<any> {
    if (this.lot) {
      return this.saveLotObservable(cancelWait);
    } else {
      return this.saveDossierObservable(cancelWait);
    }
  }


  private accept(): void {
    let saveObs: Observable<ValidationResultDTO>;
    // Unicamente hay lote si estamos en el Paso 2 (Lote cero, Lote 1...)
    if (this.lot) {
      saveObs = this.saveLotIfNecessary(true)

      // Se limpia antes de evaluar
      this.correctoPaso1 = true;

      // Si es una FE de dos pasos y tiene errores el Paso 1
      if (this.hasPreviousStep()) {
        const validationResult = this.dossier?.validationResult;
        const hasErrors =
          validationResult?.errors?.length > 0 &&
          validationResult.result === 'ERROR';

        if (hasErrors && !this.dossier.breakdownLot.apportioned) {
          this.correctoPaso1 = false;
        }
      }

    } else {
      saveObs = this.saveProjectIfNecessary(undefined, true, true);
    }

    this.subscribe(saveObs.pipe(
      catchError((error: any) => {
        this.waitService.cancelWaiting();
        return throwError(error);
      }),
      tap((validation: ValidationResultDTO) => {

        let hasErrors2 =
          validation?.errors?.length > 0 &&
          validation.result === 'ERROR';

        if (this.task) {
          // FE de 1 solo paso esta variable no se debería tener en cuenta
          // Si tiene errores en el Paso 2, que no salga el mensaje del Paso 1
          if (!this.hasPreviousStep() || (this.hasPreviousStep() && hasErrors2 && !this.dossier.breakdownLot.apportioned)) {
            this.correctoPaso1 = true;
          }

          // Si es correcto el Paso 1 funciona como siempre procesa la tarea
          if (this.correctoPaso1) {
            this.processTask(true);
          } else {
            // Si en incorrecto no procesa la tarea y muestra un mensaje emergente
            this.waitService.cancelWaiting();
            this.exit(false);
            // this.task.work.validationResult=
          }
        } else if (this.formPlycaRef.formGroup.dirty) {
          this.subscribe(this.saveObservable().pipe(
            tap(() => this.exit(false))
          ));
        } else {
          this.waitService.cancelWaiting();

          if (this.lot === undefined) {
            // Si tiene lotes la validación de la pantalla, tienen que ser OK y los lotes tienes que estar en estado cumplimentado
            // Aceptar (Paso I)
            if ((validation === undefined || validation === null) && (this.isCorrecStateLots())) {
              this.exit(false);
            } else {
              this.exit((validation?.result !== ResultTypeDTO.OK && validation?.result !== ResultTypeDTO.WARNING) || !this.isCorrecStateLots());
            }
          } else {
            // No tiene lotes
            // Aceptar (Paso II)
            // Estan todas las validaciones OK, no retorna validaciones, con lo cual puede salir de la pantalla
            if (validation === undefined || validation === null) {
              this.exit(false);
            } else {
              // No quiero que salga el mensaje del Paso 1 que tiene fallos en el caso de que haya fallos en el Paso 2
              if (validation?.result !== ResultTypeDTO.OK && validation?.result !== ResultTypeDTO.WARNING) {
                if (!this.dossier.breakdownLot.apportioned) {
                  this.correctoPaso1 = true;
                }
              }
              this.exit(validation?.result !== ResultTypeDTO.OK && validation?.result !== ResultTypeDTO.WARNING);
            }
          }
        }
      })
    ));
  }

  /*processTask(reactivate = true) {
    // validar work

    let messageConf = this.translateService.instant('La Ficha Expediente no ha sido completada, verifique se han cumplimentado los datos obligatorios del "Paso 1" y del "Paso 2". ¿Qué operación desea realizar?');
    if (!this.correctoPaso1) {
      this.waitService.startWaiting();
      this.confirmationService.confirm({
        message: messageConf,
        acceptLabel: this.translateService.instant('GenericDossier.continueEditing'),
        rejectLabel: this.translateService.instant('GenericDossier.exit'),
        accept: () => {
          super.processTask(true);
        },
        reject: () => this.waitService.cancelWaiting()
      });
      this.waitService.cancelWaiting();
    }
  }*/


  private loadStepsDefinition(): Observable<any> {
    console.log('loadStepsDefinition + waitservice');
    this.waitService.startWaiting();
    // 1. LEER CONFIGURACIONES
    return this.plycaService.getProcurementProjectSteps('procurementProject/procurementProjectDefinition.json').pipe(
      switchMap((stepsDef: ProcurementProjectDefinitionsDTO) => {
        console.log('resultado de getProcurementProjectSteps');
        // this.stepsDefinition = stepsDef;
        console.log('2.1) SI ES UN EXPEDIENTE NUEVO');
        // 2.1) SI ES UN EXPEDIENTE NUEVO
        //   a) Si viene como modelo, con formid
        //   b) SI SOLAMENTE HAY UNO SE ACCEDE DIRECTAMENTE AL FORMULARIO CORRESPONDIENTE (selectStepDefinition)
        if (this.formid) {
          console.log(' a) Si viene como modelo, con formid');
          // return this.selectStepDefinition(this.stepsDefinition.definitions.find(x => x.identifier === this.formid), this.model);
          return this.selectStepDefinition(stepsDef.definitions.find(x => x.identifier === this.formid) /*, this.model*/);
        } else {
          // 2.2) SI EL EXPEDIENTE EXISTE SE LEE Y SE RECUPERA EL FORMULARIO A ABRIR DEL CAMPO FORMID
          console.log(' 2.2) SI EL EXPEDIENTE EXISTE SE LEE Y SE RECUPERA EL FORMULARIO A ABRIR DEL CAMPO FORMID');
          return this.plycaService.getProcurementProject(this.dossierId).pipe(
            switchMap(result => {
              console.log('resultado de getProcurementProject');
              // 1. RECUPERAR FORMULARIO DE TAREA
              let formId = this.getFormIdFromTask();
              // 2. SI NO LLEGA SE RESPETA EL QUE ESTA EN EL EXPEDIENTE
              if (!formId) {
                formId = result.formId;
              }
              let selectedStep;
              // Buscamos la definición de formulario asociada al project
              if (formId) {
                selectedStep = stepsDef.definitions.find(
                  step => step.identifier === formId
                );
                console.log('SELECCIONANDO FORMULARIO: ', formId, selectedStep);
              }
              // HACK (NO DEBERIA PASAR): si no se localiza la definicion del formulario utilizamos la primera
              if (!selectedStep) {
                selectedStep = stepsDef.definitions[0];
                console.log(
                  'SELECCIONANDO FORMULARIO. NO SE HA LOCALIZADO EL FORMULARIO DEL PROYECTO. APERTURA POR DEFECTO: ',
                  formId,
                  selectedStep
                );
              }
              return this.selectStepDefinition(selectedStep);
            }
            )
          );
        }
      }),
      // switchMap(() => this.waitUntilFormLoaded()),
      catchError((error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);
        this.plycaErrorHandler.showServerError(error);
        return EMPTY;
      }),
      finalize(() => {
        console.log('Componente cargado');
        this.waitService.cancelWaiting();
        this.loaded = true;
      })
    );
  }

  public getHeaderFormStep1(stepDefinition: ProcurementProjectStepsDefinitionDTO): string {
    let formId = '';
    if (stepDefinition) {
      formId = stepDefinition.identifier;
    } else {
      formId = this.dossier.formId;
    }
    if (formId) {
      if (formId == 'MINOR_FE_AYUMAD') {
        return this.translateService.instant('ProcurementProjectAYMAD.headerStep1.MINOR');
      }
      if (formId == 'FE_CBAM_AYMAD') {
        return this.translateService.instant('ProcurementProjectAYMAD.headerStep1.CBAM');
      }
      if (formId == 'FE_CSDA_AYMAD') {
        return this.translateService.instant('ProcurementProjectAYMAD.headerStep1.CSDA');
      }
      if (formId == 'FE_AYUMAD') {
        return this.translateService.instant('ProcurementProjectAYMAD.headerStep1.CONT');
      }
      if (formId == 'FE_AM_AYUMAD') {
        return this.translateService.instant('ProcurementProjectAYMAD.headerStep1.AM');
      }

    } else {
      return stepDefinition.name;
    }

  }

  public getHeaderFormStep2(editLot: ProcurementProjectLotDTO) {
    let formId = editLot.parent.formId;
    if (formId) {
      if (formId == 'FE_AYUMAD') {
        if (editLot && editLot.lotId !== null && editLot.lotId !== undefined && editLot.lotId == 0) {
          return this.translateService.instant('ProcurementProjectAYMAD.headerStep2.CONT');
        } else {
          return this.translateService.instant('ProcurementProjectAYMAD.headerStep2.CONTLOT') + editLot.lotNumber;
        }
      }
      if (formId == 'FE_AM_AYUMAD') {
        if (editLot && editLot.lotId !== null && editLot.lotId !== undefined && editLot.lotId == 0) {
          return this.translateService.instant('ProcurementProjectAYMAD.headerStep2.AM');
        } else {
          return this.translateService.instant('ProcurementProjectAYMAD.headerStep2.AMLOT') + editLot.lotNumber;
        }
      }
    }
  }

  private selectStepDefinition(
    stepDefinition: ProcurementProjectStepsDefinitionDTO,
  ): Observable<any> {
    console.log('selectStepDefinition');
    this.stepDefinition = stepDefinition;
    this.currentStep = 0;
    this.setActionButtons();
    // si es un nuevo expediente utilizar para la precarga la llamada a new con la configuración del step seleccionado
    if (!this.dossierId) {
      this.dossierId = 'new';
      this.isNewDossier = true;
      // Si el step tiene configuraciones se utilizan para invocar al  new
      if (stepDefinition.configurations) {
        this.dossierId += '?configurations=' + stepDefinition.configurations;
      }
      /*if (this.stepDefinition.steps.length > 1) {
        this.setHeader('PASO I: DATOS BÁSICOS DEL EXPEDIENTE');
      } else {
        this.setHeader(this.translateService.instant('ProcurementProject.new') + ': ' + stepDefinition.name);
      }*/
      this.setHeader(this.getHeaderFormStep1(stepDefinition));
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.CREATE_DOSSIER));
      return this.loadDossier();
    } else {
      console.log('Expediente existente, preparar');
      /*if (this.stepDefinition.steps.length > 1) {
        this.setHeader('PASO I: DATOS BÁSICOS DEL EXPEDIENTE');
      } else {
        this.setHeader(this.translateService.instant('ProcurementProject.new') + ': ' + stepDefinition.name);
      }*/
      // si el expediente ya esta creado se invoca al loadDossier con la expansion necesaria
      this.setHeader(this.getHeaderFormStep1(stepDefinition));
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.CREATE_DOSSIER));
      let expansionDossier: string;
      if (this.dossierId && this.dossierId.indexOf('?') > 0) {
        expansionDossier = '&expand=';
      } else {
        expansionDossier = '?expand=';
      }
      expansionDossier += this.getDossierExpansion();
      return this.loadDossier(expansionDossier);
    }
  }

  private getDossierExpansion(): string {
    return (this.stepDefinition.steps.length === 1) ? PROJECT_EXPANSION_ONESTEP : PROJECT_EXPANSION_TWOSTEPS;
  }

  private loadDossier(expansion?: string): Observable<any> {
    console.log('loadDossier');
    this.loaded = false;
    if (this.isBasedContract) {
      let configuration = this.stepDefinition.configurations;
      return this.plycaService
        .getProcurementProjectBasedContract(this.frameworkAgreementParent, this.contractDivisionFrameworkAgreement,
          String(this.isBasedContract), configuration)
        .pipe(
          map(
            (result) => {
              console.log('resultado de getProcurementProject');
              console.log(result);
              console.log('Llamada a processDossierForm');
              return this.processDossierForm(result);
            }
          ));
      // getProcurementProjectBasedContract
    } if (this.isSpecificContract) {
      let configuration = this.stepDefinition.configurations;
      return this.plycaService
        .getProcurementProjectSpecificContract(this.dynamicPurchasingSystemParent, this.categorySelectedSDA, this.cpvSelectedSDA,
          String(this.isSpecificContract), configuration)
        .pipe(
          map(
            (result) => {
              console.log('resultado de getProcurementProject');
              console.log(result);
              console.log('Llamada a processDossierForm');
              return this.processDossierForm(result);
            }
          ));
    } else {
      return this.plycaService
        .getProcurementProject(this.dossierId, expansion).pipe(
          switchMap(
            (result) => {
              console.log('resultado de getProcurementProject');
              console.log(result);
              console.log('Llamada a processDossierForm');
              return this.processDossierForm(result);
            }
          ));
    }
  }

  private processDossierForm(_dossier: ProcurementProjectDTO): Observable<any> {
    console.log('processDossierForm');

    // etiquetas
    this.subscribe(
      this.helpService.showContextHelpObservable(HelpType.CREATE_DOSSIER));

    this.loaded = false;
    if (this.dossier) {
      this.formService.merge(this.dossier, _dossier);
    } else {
      this.dossier = _dossier;
    }
    this.dossierId = this.dossier.identifier;
    // establecer el identificador del formulario
    this.dossier.formId = '' + this.stepDefinition.identifier;
    // Si tiene parametros establece el valor de los mismos
    if (this.isNewDossier && this.stepDefinition.default) {
      lodash.merge(this.dossier, this.stepDefinition.default);
    }
    // Formato json servidor
    if (this.isNewDossier && this.stepDefinition.defaultFields) {
      this.stepDefinition.defaultFields.forEach((f: ProjectDefaultFieldDTO) => {
        console.log('Estableciendo el campo ' + f.jsonField + ' con valor ' + f.value);
        // Formato json servidor
        let defaultValue;
        console.log('Estableciendo el campo ' + f.jsonField + ' con valor ' + f.value);
        if (f.value && f.value.includes('<>')) {
          let idParts = f.value.split('<>');
          this.plycaService.getMasterDataValues(idParts[1], idParts[0], true)
            .pipe(take(1))
            .subscribe((data: PaginationDTO<MasterData>) => {
              if (data && data.content && data.content.length > 0) {
                defaultValue = data.content[0];
                this.formService.setNestedProperty(this.dossier, f.jsonField, defaultValue);
              }
            });
        } else if (f.value && (f.value === 'true' || f.value === 'false')) {
          let defaultValueBoolean;
          let _this = this as unknown as formElementComponent;
          defaultValueBoolean = this.formService.evalExpression(f.value,
            null, null, _this, null);
          this.formService.setNestedProperty(this.dossier, f.jsonField, defaultValueBoolean);
        } else {
          this.formService.setNestedProperty(this.dossier, f.jsonField, f.value);
        }

      });
    }
    this.dto2ViewModel(this.dossier);
    console.log('llamada a loadForms');
    return this.loadForms(this.currentStep);
  }


  public cancelLotEdition(save = false) {
    this.editProject(save);
  }

  public nextStep() {
    if (this.hasNextStep()) {
      this.editZeroLot();
    }
  }

  private isStep2(): boolean {
    return this.getCurrentStep()?.value === 1;
  }

  private isStep1(): boolean {
    return this.getCurrentStep()?.value === 0;
  }

  public hasPreviousStep(): boolean {
    return this.getCurrentStep()?.value > 0;
  }

  public hasNextStep(): boolean {
    return this.getCurrentStep().value < this.stepDefinition?.steps?.length - 1;
  }

  private getCurrentStep(): ProcurementProjectStepDTO {
    return (this.stepDefinition != null && this.stepDefinition.steps.length > 0) ?
      this.stepDefinition.steps.find(t => t.value === this.currentStep)
      : undefined;
  }

  private editProject(save = true) {
    let obs: Observable<any>;
    if (save && this.formPlycaRef.formGroup.dirty && !this.readonly) {
      this.waitService.startWaiting(this.translateService.instant('GenericDossier.changing'));
      obs = this.insertOrUpdateLot();
    } else {
      this.waitService.startWaiting();
      obs = of({});
    }
    this.subscribe(obs.pipe(
      catchError((error: any) => {
        this.uiService.showMessage('No se puede cambiar de paso hasta que corrija los errores');
        return throwError(error);
      }),
      tap(() => {
        this.currentStep = 0;
      }),
      switchMap(() => {
        // Si vene del volver de un expediente con lotes, siempre tiene que actualizar la información del expediente, ya que puede ser
        // que haya estado navegando entre lotes y no haya actualizado el ultimo lote pero si los anteriores
        if (!save) {
          this.lotModified = true;
        }
        if (this.lotModified) {
          // actualizar información del expediente
          return this.loadDossier('?expand=' + this.getDossierExpansion());
        } else {
          return this.loadForms(0)
        }
      }),
      tap((formLoaded: boolean) => {
        if (formLoaded) {
          //this.setHeader('PASO I: DATOS BÁSICOS DEL EXPEDIENTE');
          this.setHeader(this.getHeaderFormStep1(null));
        }
      }),
      finalize(() => {
        this.waitService.cancelWaiting();
        this.loaded = true;
      })
    ));
  }



  /*
   * LOGICA DE NEGOCIO DEL FORMULARIO
   */

  // invocar en la consulta para adaptar el dto al modelo de vista
  private dto2ViewModel(exp: ProcurementProjectDTO) {
  }

  // invocar antes de guardar
  private viewModel2DTO(): ProcurementProjectDTO {
    // trabajamos con una copia del objeto
    let tmpExp: ProcurementProjectDTO;
    tmpExp = lodash.cloneDeep(this.dossier);
    console.log('antes de limpiar', this.dossier, tmpExp);
    tmpExp.validationResult = undefined;
    // limpiar variables de apoyo de tablas
    tmpExp = JSON.parse(
      JSON.stringify(tmpExp, (k, v) => (k === '_parent' ? undefined : v))
    );
    // if (this.isApportioned() && this.isStep1()) {
    if (this.hasNextStep() && this.isStep1()) {
      // El context.name SIEMPRE tiene que ser Step1 en el paso 1, independientemente de si tiene o no lotes.!!!!!
      if (!tmpExp.context) {
        tmpExp.context = new ObjectContextDTO();
      }
      // en caso del paso 1 con lotes establecer el nombre del contexto
      // para que el servidor no modifique los datos de lotes que se editan en el paso 2
      tmpExp.context.name = 'Step1';
    } /*else {
      tmpExp.context.name = 'Step2Cont';
      // Si es Acuerdo Marco
      if (tmpExp.classification?.complementarySystem?.identifier && tmpExp.classification?.complementarySystem?.identifier == 'AM<>SISTCOMPLEMENTARIO') {
        tmpExp.context.name = 'Step2FrameworkAgreementMode';
      } else {

      }
    }*/
    console.log('despues de limpiar', this.dossier, tmpExp);
    // Etiquetas que necesitan un identifier
    tmpExp.labelCPV = 'En caso de que el el expediente se comunique a PLACSP, se enviará como CPV principal del expediente el primero de esta tabla';
    return tmpExp;
  }

  changeClassificationCompanySubgroup(model: any, changes?: any) {
    console.log('EJECUTADO changeClassificationCompanySubgroup', model, changes);
    let reset = procurementProjectAYMADComponent.resetChange(changes);
    if (reset) {
      //si se cambia el subgrupo hay que resetear la categoria
      model.category = undefined;
    }
  }

  changeClassificationCompanyGroup(model: any, changes?: any) {
    console.log('EJECUTADO changeClassificationCompanyCategory', model, changes);
    let reset = procurementProjectAYMADComponent.resetChange(changes);
    if (reset) {
      //si se cambia el grupo hay que resetar el subgrupo y la categoria.
      model.subgroup = undefined;
      model.category = undefined;
    }

  }

  public static resetChange(changes?: any) {
    let oldValue = changes.oldValue;
    let newValue = changes.newValue;
    //si el valor nuevo NO es nulo y el valor antiguo no es nulo y son diferentes las empresas se resetea el representante
    //si se elimina el valor de la emprea tambien se limpia
    let reset = ((oldValue && newValue) && (oldValue.identifier != newValue.identifier)) || (newValue === undefined);
    console.log('======resetChange', reset);
    return reset;
  }

  changeCompanyToInvite(model: any, changes?: any) {
    console.log('EJECUTADO changeCompanyToInvite', model, changes);
    let reset = procurementProjectAYMADComponent.resetChange(changes);
    if (reset) {
      let companytoInvite = model._parent.breakdownLot.totalLots.companyToInvites
        .find(companyToInvite => companyToInvite.company.identifier === changes.newValue.identifier);
      if (companytoInvite && companytoInvite.representative) {
        companytoInvite.representative = undefined;
      }
    }
  }



  private loadForms(_index: number): Observable<any> {
    console.log('loadForms');
    let stepDefinition = this.stepDefinition.steps[_index];
    if (_index === 0) {
      this.lot = undefined;
    }
    console.log(
      'cambiando de step',
      this.stepDefinition,
      _index,
      this.stepDefinition.steps[_index]
    );
    const formModel = (this.lot) ? this.lot : this.dossier;
    let _frmConfig = new FormConfig(undefined, stepDefinition.formConfig, formModel);
    _frmConfig.showValidations = true;
    /// FUNCIONES PROPIAS DE AYUMAD

    // Desglosar Lote
    _frmConfig.functions.push({
      identifier: 'breakdownLot',
      fn: this.editLot.bind(this)
    });


    // FUNCIONES PARA FICHA EXPEDIENTE MENOR //

    // Contrato Reservado
    _frmConfig.functions.push({
      identifier: 'cleanReservedContract',
      fn: this.cleanReservedContract
    });
    _frmConfig.functions.push({
      identifier: 'cleanSubtype',
      fn: this.cleanSubtype
    });
    _frmConfig.functions.push({
      identifier: 'setEmailCompanyToInvite',
      fn: this.setEmailCompanyToInvite
    });
    // FIN DE FUNCIONES PARA EL MENOR //

    // FUNCIONES PARA FICHAEXPEDIENTE DOS PASOS//
    _frmConfig.functions.push({
      identifier: 'isVisibleProcessJustificationNegotiated',
      fn: this.procurementProjectValidations
        .isVisibleProcessJustificationNegotiated
    });
    _frmConfig.functions.push({
      identifier: 'valueChangeFinancingSuspCond',
      fn: this.valueChangeFinancingSuspCond
    });
    _frmConfig.functions.push({
      identifier: 'evtChangeTypeCode',
      fn: this.evtChangeTypeCode
    });
    _frmConfig.functions.push({
      identifier: 'evtChangeType',
      fn: this.evtChangeType
    });
    _frmConfig.functions.push({
      identifier: 'valueBudgetTotalTaxesLot',
      fn: this.valueBudgetTotalTaxesLot
    });
    _frmConfig.functions.push({
      identifier: 'getVisibleLotSolvencyAccreditation',
      fn: this.getVisibleLotSolvencyAccreditation.bind(this)
    });

    _frmConfig.functions.push({
      identifier: 'cleanTableUnitPrice',
      fn: this.cleanTableUnitPrice
    });
    _frmConfig.functions.push({
      identifier: 'valueBudgetTotalTax_UnitPrice',
      fn: this.valueBudgetTotalTax_UnitPrice
    });

    _frmConfig.functions.push({
      identifier: 'setValueProvGuarantee',
      fn: this.setValueProvGuarantee
    });
    _frmConfig.functions.push({
      identifier: 'setValueProvGuaranteeJustAM',
      fn: this.setValueProvGuaranteeJustAM
    });
    _frmConfig.functions.push({
      identifier: 'viewFormRevPrice',
      fn: this.viewFormRevPrice.bind(this)
    });
    _frmConfig.functions.push({
      identifier: 'cleanTableFormRevPrice',
      fn: this.cleanTableFormRevPrice
    });


    _frmConfig.functions.push({
      identifier: 'evt_SubContractTermAuthorized',
      fn: this.evt_SubContractTermAuthorized
    });
    _frmConfig.functions.push({
      identifier: 'evt_DataOutSourcing',
      fn: this.evt_DataOutSourcing
    });


    _frmConfig.functions.push({
      identifier: 'setSpecialExecutionCondition',
      fn: this.setSpecialExecutionCondition.bind(this)
    });
    _frmConfig.functions.push({
      identifier: 'setSocAwardCriteria',
      fn: this.setSocAwardCriteria.bind(this)
    });
    _frmConfig.functions.push({
      identifier: 'editablePaymentPriceAYMAD',
      fn: this.editablePaymentPriceAYMAD
    });
    _frmConfig.functions.push({
      identifier: 'setValueSubContractTermAuthorized',
      fn: this.setValueSubContractTermAuthorized
    });
    _frmConfig.functions.push({
      identifier: 'cleanReservedContractLot',
      fn: this.cleanReservedContractLot
    });
    _frmConfig.functions.push({
      identifier: 'calculateBudgetsUnitPrice',
      fn: this.calculateBudgetsUnitPrice.bind(this)
    });
    _frmConfig.functions.push({
      identifier: 'viewArticle',
      fn: this.viewArticle.bind(this)
    });
    _frmConfig.functions.push({
      identifier: 'valueUTDays',
      fn: this.valueUTDays
    });

    // FIN FUNCIONES FE DOS PASOS//
    // FUNCIONES AM //
    _frmConfig.functions.push({
      identifier: 'setPlannedTenderBasedFrameworkAgreementAdapt_AM',
      fn: this.setPlannedTenderBasedFrameworkAgreementAdapt_AM
    });

    _frmConfig.functions.push({
      identifier: 'evtChangeValueFrameworkAgreementAwardType',
      fn: this.evtChangeValueFrameworkAgreementAwardType
    });


    /// FIN DE FUNCIONES DE AYUMAD/////////////////////

    _frmConfig.functions.push({
      identifier: 'changeCompanyToInvite',
      fn: this.changeCompanyToInvite
    });

    _frmConfig.functions.push({
      identifier: 'changeClassificationCompanySubgroup',
      fn: this.changeClassificationCompanySubgroup
    });

    _frmConfig.functions.push({
      identifier: 'changeClassificationCompanyGroup',
      fn: this.changeClassificationCompanyGroup
    });
    _frmConfig.functions.push({
      identifier: 'loadSelectionAwardCriteria',
      fn: this.loadSelectionAwardCriteria
    });

    _frmConfig.functions.push({
      identifier: 'loadDataAMSDA',
      fn: this.loadDataAMSDA
    });

    _frmConfig.functions.push({
      identifier: 'openCPVSelector',
      fn: this.openCPVSelector
    });
    _frmConfig.functions.push({
      identifier: 'openCPVSelector2',
      fn: this.openCPVSelector2
    });
    _frmConfig.functions.push({
      identifier: 'openProjectSelector',
      fn: this.openProjectSelector
    });
    _frmConfig.functions.push({
      identifier: 'newLot',
      fn: this.newLot.bind(this)
    });
    _frmConfig.functions.push({
      identifier: 'removeLot',
      fn: this.removeLot
    });
    _frmConfig.functions.push({
      identifier: 'copyLot',
      fn: this.copyLot.bind(this)
    });

    this.procurementProjectValidations.registerFunctions(_frmConfig);
    this.procurementProjectValidationscbam.registerFunctions(_frmConfig);
    this.procurementProjectValidationsAM.registerFunctions(_frmConfig);
    this.procurementProjectValidationscsda.registerFunctions(_frmConfig);
    this.procurementProjectValidationsMinor.registerFunctions(_frmConfig);

    _frmConfig.functions.push({
      identifier: 'openRequestMaterial',
      fn: this.openRequestMaterial
    });
    _frmConfig.functions.push({
      identifier: 'loadCompanyToInvite',
      fn: this.loadCompanyToInvite
    });
    _frmConfig.functions.push({
      identifier: 'loadRequestMaterial',
      fn: this.loadRequestMaterial
    });
    _frmConfig.functions.push({
      identifier: 'setDefaultValueFrameworkAgreementCriteria',
      fn: this.setDefaultValueFrameworkAgreementCriteria
    });

    _frmConfig.functions.push({
      identifier: 'isActiveBaseContractNoRelated',
      fn: this.isActiveBaseContractNoRelated
    });
    _frmConfig.functions.push({
      identifier: 'isEnabledTenderBasedFrameworkAgreement',
      fn: this.isEnabledTenderBasedFrameworkAgreement
    });
    // Funciones para Gobernanza
    _frmConfig.functions.push({
      identifier: 'valueEUDirective',
      fn: this.valueEUDirective
    });
    _frmConfig.functions.push({
      identifier: 'valueNumLicitableLots',
      fn: this.valueNumLicitableLots
    });
    _frmConfig.functions.push({
      identifier: 'changeApportioned',
      fn: this.changeApportioned.bind(this)
    });
    _frmConfig.functions.push({
      identifier: 'evtChangeManualTaxCalculation',
      fn: this.evtChangeManualTaxCalculation.bind(this)
    });

    _frmConfig.functions.push({
      identifier: 'clearLotTotalTaxes',
      fn: this.clearLotTotalTaxes
    });
    _frmConfig.functions.push({
      identifier: 'valueAttHarmonizedRegulationAYMADCBAM',
      fn: this.valueAttHarmonizedRegulationAYMADCBAM
    });
    // FUNCIONES ASOCIADAS A LOS MODOS --------------------------------
    // FIN FUNCIONES ASOCIADAS A LOS MODOS -----------------

    // FUNCIONES EXPORTACION - IMPORTACION EXCEL
    _frmConfig.functions.push({
      identifier: 'exportUnitPrice',
      fn: this.exportUnitPrice.bind(this)
    });
    _frmConfig.functions.push({
      identifier: 'importUnitPrice',
      fn: this.importUnitPrice.bind(this)
    });


    // templates
    let templates = new Array<TemplateDef>();
    // template emisor
    let fromTemplate = new TemplateDef();
    let fromTemplateAM = new TemplateDef();

    fromTemplateAM.identifier = 'budgetSummaryAMTemplate';
    fromTemplateAM.template = this.budgetSummaryAMTemplate;

    fromTemplate.identifier = 'budgetSummaryTemplate';
    fromTemplate.template = this.budgetSummaryTemplate;

    templates.push(fromTemplate);
    templates.push(fromTemplateAM);
    _frmConfig.templates = templates;
    if (this.readonly) {
      _frmConfig.readonly = true;
    }
    this.formConfig = _frmConfig;
    return this.waitUntilFormLoaded();
  }

  private waitUntilFormLoaded(): Observable<boolean> {
    return this.formPlycaRef.getCompleted().pipe(
      skipWhile((completed: boolean) => !completed),
      take(1)
    );
  }

  private saveDossierObservable(cancelWait = true): Observable<any> {
    this.waitService.startWaiting(this.translateService.instant('GenericDossier.changing'));
    const dossierId = this.dossier.identifier;
    return this.insertOrUpdateProject().pipe(
      tap(() => {
        // mostrar mensaje
        const messageKey = (dossierId) ? 'GenericDossier.update.ok' : 'GenericDossier.created';
        this.uiService.showSuccess(
          this.translateService.instant(messageKey, { identifier: this.getDossierId(this.dossier) }),
          this.translateService.instant('General.info'), 'success');
      }),
      finalize(() => {
        if (cancelWait) {
          this.waitService.cancelWaiting();
        }
      })
    );
  }
  // saveAction() {
  //   this.waitService.startWaiting();
  //   this.subscribe(this.save().pipe(finalize(() => {
  //     this.waitService.cancelWaiting();
  //     this.loaded = true;
  //   })),
  //     data => {
  //       if (this.task && !this.isStatelessTask()) {
  //         let stepCurrent = this.getCurrentStep();
  //         //if (stepCurrent.lastStep && data.isValidatedOk) {
  //         // Se elimina ya que sino en el caso de que haya errores no procesa la tarea y no sale el Mantener
  //         if (stepCurrent.lastStep) {
  //           this.waitService.startWaiting('Procesando los datos de la tarea ...');
  //           // this.procesandoTarea = true;
  //           this.processTask();
  //         }
  //       }
  //     }
  //   );
  // }

  private getContext(existIdentifier: boolean) {
    let validationContext;
    if (existIdentifier) {
      validationContext = 'Update';
    } else {
      validationContext = 'Insert';
    }

    // si hay definido un grupo de validaciones asociado al paso  prevalece sobre la definición de validación asociado al formulario
    // si hay definido un grupo de validaciones a la definición de formulario se especifica
    let stepCurrent = this.getCurrentStep();
    if (
      stepCurrent.validationsGroup === undefined &&
      this.stepDefinition.validationsGroup
    ) {
      validationContext += this.stepDefinition.validationsGroup;
    } else if (stepCurrent.validationsGroup) {
      validationContext += stepCurrent.validationsGroup;
    }
    return validationContext;
  }

  private validateLot(showErrors = false): Observable<ValidationResultDTO> {
    let model = this.viewModelLot2DTO();
    let validationContextGroupValidation = this.getContext(
      model.identifier !== undefined ? true : false
    );
    return this.plycaService.validate<ProcurementProjectLotDTO>(this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION,
      validationContextGroupValidation, model)
      .pipe(
        tap((validation: ValidationResultDTO) => {
          if (showErrors && validation.result !== ResultTypeDTO.OK) {
            this.manageActionError(new ValidationResultDTOError(validation), false);
          }
        }),
        catchError((error: any) => {
          this.manageActionError(error, false);
          return throwError(error);
        })
      );
  }

  private validateProject(showErrors = false): Observable<ValidationResultDTO> {
    let model = this.viewModel2DTO();
    let validationContextGroupValidation = this.getContext(
      model.identifier !== undefined ? true : false
    );
    return this.plycaService.validate<ProcurementProjectDTO>(this.configuration.PROCUREMENTPROJ_SERVICE_URL,
      validationContextGroupValidation, model)
      .pipe(
        tap((validation: ValidationResultDTO) => {
          if (showErrors && validation.result !== ResultTypeDTO.OK) {
            this.manageActionError(new ValidationResultDTOError(validation), false);
          }
        }),
        catchError((error: any) => {
          this.manageActionError(error, false);
          return throwError(error);
        })
      );
  }


  private insertOrUpdateLot(): Observable<ProcurementProjectLotDTO> {
    let model = this.viewModelLot2DTO();
    let validationContextGroupValidation = this.getContext(
      model.identifier !== undefined ? true : false
    );

    if (this.formPlycaRef) {
      this.formPlycaRef.deleteFormErrors();
    }
    let obs: Observable<any>;
    if (model.identifier) {
      // Se desea actualizar el XML
      obs = this.plycaService.updateObject<ProcurementProjectLotDTO>(this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION,
        model, validationContextGroupValidation);
    } else {
      obs = this.plycaService.insert<ProcurementProjectLotDTO>(this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION,
        model, validationContextGroupValidation).pipe(
          tap((updatedLot: ProcurementProjectLotDTO) => {
            model.identifier = updatedLot.identifier;
          })
        );
    }
    return obs.pipe(
      catchError((error: any) => {
        this.manageActionError(error, false);
        return throwError(error);
      }),
      tap((updatedLot: ProcurementProjectLotDTO) => {
        this.lotModified = true;
        if (updatedLot?.validationResult && updatedLot?.validationResult?.result !== ResultTypeDTO.OK) {
          // actualizar validaciones
          this.manageActionError(new ValidationResultDTOError(updatedLot.validationResult), false);
        }
      }),

      switchMap((updatedLot: ProcurementProjectLotDTO) => {
        if (updatedLot.lotId !== 0) {
          this.waitService.startWaiting('Consultando lote ...');
        } else {
          this.waitService.startWaiting('Consultando expediente ...');
        }
        return this.getProcurementProjectLot(updatedLot.identifier).pipe(
          tap((updatedLotVal: ProcurementProjectLotDTO) => {
            // Se actualiza el objeto que devuelve con las validaciones
            if (updatedLotVal) {
              updatedLotVal.validationResult = updatedLot.validationResult;
            }
            // Se actualiza el valor anterior del valor estimado
            updatedLotVal.budget.estimatedAmountPrevious = updatedLot.budget.estimatedAmount;
          })
        );
      }),
      switchMap((updatedLot: ProcurementProjectLotDTO) => {
        // Realiza operaciones con la segunda llamada (anidada)
        return this.getAuxProperties(updatedLot).pipe(
          map((result: any[]) => updatedLot)
        );
      }),
      tap((updatedLot: ProcurementProjectLotDTO) => {
        // actualizar datos del lote
        this.formService.merge(this.lot, updatedLot);
        // marcar el formulario como no modificado tras guardar y actualizar datos en pantalla
        this.formPlycaRef.formGroup.markAsPristine();
        // Como ha grabado el lote puede ser que haya modificado el estado del lote,
        // esta variable sirve para que el boton Aceptar del paso 1 siempre gabe, ya que esto puede afectar al estado del expediente
        /*if (updatedLot.lotId && updatedLot.lotId !== 0) {
          this.saveAlways = true;
        }*/
      })

    );
  }


  private getProcurementProjectLot(lotId: string) {
    const expansion = {
      expand: LOT_EXPANSION
    };
    return this.plycaService.get<ProcurementProjectLotDTO>(this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION,
      lotId,
      expansion).pipe(
        tap((updatedLot: ProcurementProjectLotDTO) => {
          updatedLot.parent = this.dossier;
        })
      );
  }

  private insertOrUpdateProject(additionalQueryExpansion: string = undefined, updateModel = true): Observable<ProcurementProjectDTO> {
    let model = this.viewModel2DTO();
    let expansion = '?expand=' + this.getDossierExpansion();
    let validationContextGroupValidation = model.context?.name;
    if (model.classification?.complementarySystem?.identifier && model.classification?.complementarySystem?.identifier == 'AM<>SISTCOMPLEMENTARIO') {
      validationContextGroupValidation = 'Step1FrameworkAgreementMode';
    }
    if (validationContextGroupValidation === undefined) {
      validationContextGroupValidation = this.getContext(
        model.identifier !== undefined ? true : false
      );
    }
    if (this.formPlycaRef) {
      this.formPlycaRef.deleteFormErrors();
    }
    // si es el último paso consultar acciones para ver si esta todo OK
    let obs: Observable<any>;
    if (model.identifier) {
      obs = this.plycaService.updateObject<ProcurementProjectDTO>(this.configuration.PROCUREMENTPROJ_SERVICE_URL,
        model, validationContextGroupValidation);
    } else {
      obs = this.plycaService.insert<ProcurementProjectDTO>(this.configuration.PROCUREMENTPROJ_SERVICE_URL,
        model, validationContextGroupValidation).pipe(
          tap((updatedDossier: ProcurementProjectDTO) => {
            model.identifier = updatedDossier.identifier;
            this.dossierId = model.identifier;
          })
        );
    }
    return obs.pipe(
      catchError((error: any) => {
        this.manageActionError(error, false);
        return throwError(error);
      }),
      tap((updatedProject: ProcurementProjectDTO) => {
        if (updatedProject?.validationResult && updatedProject?.validationResult?.result !== ResultTypeDTO.OK) {
          // actualizar validaciones
          this.manageActionError(new ValidationResultDTOError(updatedProject.validationResult), false);
        }
      }),
      switchMap((updatedProject: ProcurementProjectDTO) => {
        if (updateModel) {
          this.waitService.startWaiting('Consultando expediente ...');
          const queryExpansion = expansion + ((additionalQueryExpansion) ? ',' + additionalQueryExpansion : '');
          return this.plycaService.getProcurementProject(updatedProject.identifier, queryExpansion).pipe(
            tap((updatedProjectVal: ProcurementProjectDTO) => {
              // Se actualiza el objeto que devuelve con las validaciones
              if (updatedProjectVal) {
                updatedProjectVal.validationResult = updatedProject.validationResult;
              }
            })

          );
        } else {
          return of(updatedProject);
        }
      }),
      tap((updatedProject: ProcurementProjectDTO) => {
        if (updateModel) {
          // actualizar con información del expediente con su expansion
          this.updateProjectModel(updatedProject);
        }
      })
    );
  }

  private updateProjectModel(updatedProject: ProcurementProjectDTO): void {
    this.formService.merge(this.dossier, updatedProject);
    // marcar el formulario como no modificado tras guardar y actualizar datos en pantalla
    this.formPlycaRef.formGroup.markAsPristine();
    this.formPlycaRef.updateView();
  }

  // save(newStep?: number): Observable<SaveDossierData> {
  //   this.waitService.startWaiting('Validando los datos del expediente ...');
  //   // para almacenar un modelo establecer el listadocid
  //   if (!this.dossier.documentClass) {
  //     this.dossier.documentClass = {
  //       identifier: '00000'
  //     } as DocumentClassDTO;
  //   }
  //   // VALIDATE -->
  //   let model = this.viewModel2DTO();
  //   let validationContext = 'procurementProjects/validations/';

  //   // si hay definido un grupo de validaciones asociado al paso  prevalece sobre la definición de validación asociado al formulario
  //   // si hay definido un grupo de validaciones a la definición de formulario se especifica

  //   let validationContextGroupValidation = this.getContext(
  //     model.identifier !== undefined ? true : false
  //   );
  //   if (validationContextGroupValidation) {
  //     validationContext += validationContextGroupValidation;
  //   }
  //   console.log(
  //     'VALIDANDO MODELO',
  //     model,
  //     ' con el grupo de validaciones ',
  //     validationContext
  //   );
  //   // Se validan los campos
  //   return this.formPlycaRef.getValidateObservable(validationContext, model).pipe(
  //     switchMap(validations => {


  //       // Se muestran los errores de validación
  //       console.log('Validación completada.');

  //       let validationErrors: boolean =
  //         validations.body.errors && validations.body.errors.filter(error => error.result !== "WARNING").length > 0;

  //       // Se guardan los datos del expediente y se muestra el diálog de espera de actualización
  //       let config: DynamicDialogConfig = {
  //         header: '',
  //         closeOnEscape: false,
  //         showHeader: false,
  //         width: '50%',
  //         style: { overflow: 'scroll', 'max-height': '80%' }
  //       };
  //       config['dossier'] = this.viewModel2DTO();
  //       config['task'] = this.task;
  //       config['validationContext'] = this.getContext(
  //         config['dossier'].identifier != undefined ? true : false
  //       );

  //       let stepCurrent = this.getCurrentStep();
  //       config['lastStep'] = stepCurrent.lastStep;
  //       if (newStep !== undefined && stepCurrent.value !== newStep) {
  //         config['stepChange'] = true;
  //       }

  //       config['dossier'] = this.viewModel2DTO();
  //       config['task'] = this.task;

  //       config['validationContext'] = this.getContext(
  //         config['dossier'].identifier != undefined ? true : false
  //       );

  //       // Se actualiza el expediente

  //       config['validationErrors'] = validationErrors;

  //       const ref = this.dialogService.open(saveDossierPopupAYMADComponent, config);

  //       return ref.onClose.pipe(
  //         this.onClosePopup(validationErrors, newStep, validationContext),

  //         finalize(() => {
  //           this.loaded = true;
  //           this.waitService.cancelWaiting();
  //         }));

  //       // <-- VALIDATE
  //     }));
  // }






  // private onClosePopup(validationErrors: boolean, newStep: number, validationContext: string) {
  //   return map((data: SaveDossierData) => {

  //     // if (data.popupReturnAction === 'TRAMITACIONOK') {
  //     //   this.TRAMITACIONOK = true;
  //     //   this.waitService.cancelWaiting();
  //     //   this.route.navigate(['/dossierInfo/' + data.dossier.identifier]);
  //     // } else {

  //     if (data) {
  //       data.isValidatedOk = !validationErrors;
  //       if (data.error) {
  //         console.log('SAVEDATA DEVUELVE ERROR', data.error);
  //         this.waitService.cancelWaiting();
  //         this.uiService.showSuccess(this.translateService.instant('ProcurementProject.saving.error'),
  //           this.translateService.instant('General.warning'));
  //         this.waitService.startWaiting();
  //         return data;
  //       } else {
  //         console.log('SAVEDATA CORRECTO. ACTUALIZANDO DOSSIER', data.dossier);
  //         // si grabar ha ido bien, actualizar el paso
  //         if (newStep !== undefined) {
  //           this.currentStep = newStep;
  //         }
  //         // Se recargan los datos del formulario de la ficha
  //         this.subscribe(this.processDossierForm(data.dossier),
  //           (ok) => {
  //             if (ok) {
  //               this.formPlycaRef.validate(validationContext, this.viewModel2DTO());
  //               console.log('Componente cargado');
  //               this.uiService.showSuccess(data.message, this.translateService.instant('General.info'), 'success');

  //               if (this.lot != undefined && this.lot !== null && this.lot.lotNumber !== null)
  //                 this.setHeader('PASO II: DATOS DEL LOTE ' + this.lot.lotNumber + ' - ' + this.lot.description);

  //             }
  //           }
  //         );
  //         return data;
  //       }
  //     }
  //     // }

  //   });
  // }



  public getDossierId(dossier: ProcurementProjectDTO): string {
    return dossier.contractFolderId
      ? dossier.contractFolderId
      : this.getPropuestaId(dossier);
  }

  private getPropuestaId(dossier: ProcurementProjectDTO): string {
    let propuesta = dossier.identifier;
    if (propuesta && propuesta.length > 4) {
      propuesta = propuesta.substring(0, 4) + '/' + propuesta.substring(4);
    }
    return propuesta;
  }

  public loadRequestMaterial(model: any): Observable<RequestMaterialDTO[]> {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID &&
      model.contractingSystem.originalContractingSystemID.contractFolderId
    ) {
      // se recuperan los lotes adjudicados del expediente base
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      let loteId = null;
      if (model.contractingSystem.originalContractingSystemLotID) {
        loteId = model.contractingSystem.originalContractingSystemLotID.lotId;
      } else {

        // Si no tiene categoria, porque no la ha seleccionado
        // o el Acuerdo Marco Padre no tiene lotes, en ese caso loteid=0
        if (model.procurementProjectAM.breakdownLot.apportioned == false) {
          loteId = 0;
        }
      }

      let config: DynamicDialogConfig = {
        header: this.translateService.instant(
          'ProcurementProjectLot.titleSelLotAM'

        ),
        width: '70%',
        style: { overflow: 'scroll', 'max-height': '80%' },
        styleClass: 'searchStyle'
      };
      config['contractFolderId'] = contractFolderId;
      config['origin'] = 'requestMaterial';
      config['lotId'] = loteId;

      const ref = this.dialogService.open(
        SearchLotsAwardsPopupAYMADComponent,
        config
      );

      this.subscribe(ref.onClose.pipe(
        // tap: es haz algo y devuelve lo que ha devuelto la ventana
        // map: transforma el resultado de la ventana entrando un observable y devolviendolo a otro observable
        switchMap((numLot: number) => {

          if (numLot) {
            let procurementProjectUrl =
              this.configuration.REQUEST_MATERIAL_SERVICE_URL +
              '?contractFolderId=' +
              contractFolderId +
              '&lotId=' +
              numLot;
            let resultQuery = this.plycaService.query<RequestMaterialDTO>(
              procurementProjectUrl
            );
            return resultQuery;

          }

          return of();
        }), // fin map numLot
        map((pageRequestedMaterial: PaginationDTO<RequestMaterialDTO>) => {
          if (pageRequestedMaterial) {
            let requestedMaterials = pageRequestedMaterial.content;
            let _this = this as unknown as formElementComponent;
            if (requestedMaterials) {
              requestedMaterials.forEach((requestedMaterial: RequestMaterialDTO) => {
                // generar objeto company
                let material = new RequestMaterialDTO();
                material = requestedMaterial;
                material.lot = null;
                // TODO modificar for dto_path.push(material)
                _this._addRow(material);
              });
            }
          } else {
            this.uiService.showMessage(
              this.translateService.instant(
                'ProcurementProjectLot.notExistRequestedMaterial'
              )
            );
          }
        }) // fin map pageRequestedMaterial
      ));
    } else {
      this.uiService.showMessage(
        this.translateService.instant(
          'ProcurementProjectLot.contractFolderIdCBAMRequiredRequestMaterial'
        )
      );
      return of();
    }
  }


  public loadSelectionAwardCriteria(model: any) {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID
    ) {
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      let categoria = model.contractingSystem.originalContractingSystemLotID;
      if (contractFolderId && categoria) {
        // buscar el lote para el expedienteId
        let procurementProjectUrl =
          this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION +
          '?contractFolderId=' +
          contractFolderId +
          '&lotId=' +
          categoria.lotId +
          '&expand=expansionSet:basic_criteria';
        this.subscribe(this.plycaService
          .query<ProcurementProjectLotDTO>(procurementProjectUrl)
          ,
          (result: PaginationDTO<ProcurementProjectLotDTO>) => {
            if (
              result &&
              result.content
            ) {
              // se muestra un mensaje al usuario especificando que si desea cargar los criterios
              let confirmMessage = this.translateService.instant(
                'ProcurementProjectLot.loadCriterialAM'
              );
              this.uiService.showConfirmMessage({
                message: confirmMessage,
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                  model.breakdownLot.totalLots.selectionAwardCriteria = [];
                  if (model.desglosableInfo['selectionAwardCriteria']) {
                    model.desglosableInfo['selectionAwardCriteria'] = [];
                  }
                  result.content.filter((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria && lot.selectionAwardCriteria.length > 0
                  ).forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                    (criteria: CriteriaDTO) => {
                      criteria.identifier = undefined;
                      model.desglosableInfo['selectionAwardCriteria'].push(
                        criteria
                      );
                    }
                  ));
                },
                reject: () => {
                  console.log('NO SE CARGAN LOS CRITERIOS');
                }
              });
            }
          },
          (error: any) => this.plycaErrorHandler.showServerError(error)
        );
      }
    }
    return model;
  }


  public loadCompanyToInvite(
    model: any
  ): Observable<Array<CompanyToInviteDTO>> {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID &&
      model.contractingSystem.originalContractingSystemID.contractFolderId
    ) {
      // se recuperan los lotes adjudicados del expediente base
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      let loteId = null;
      if (model.contractingSystem.originalContractingSystemLotID) {
        loteId = model.contractingSystem.originalContractingSystemLotID.lotId;
      } else {
        if (model.procurementProjectAM.breakdownLot.apportioned == false) {
          loteId = 0;
        }
      }

      let config: DynamicDialogConfig = {
        header: this.translateService.instant(
          'ProcurementProjectLot.titleSelLotAM'
        ),
        width: '70%',
        style: { overflow: 'scroll', 'max-height': '80%' },
        styleClass: 'searchStyle'
      };
      config['contractFolderId'] = contractFolderId;
      config['origin'] = 'companyToInvite';
      config['lotId'] = loteId;

      const ref = this.dialogService.open(
        SearchLotsAwardsPopupAYMADComponent,
        config
      );
      let companiesToInvites = new Array<CompanyToInviteDTO>();

      this.subscribe(ref.onClose.pipe(
        switchMap((numLot: number) => {
          // consultamos la adjudicacion del lote
          if (numLot != undefined && loteId === 0) {// Acuerdos Marco sin Lotes
            let procurementProjectUrl =
              this.configuration.AWARD_SERVICE_URL +
              '?contractFolderId=' +
              contractFolderId;
            return this.plycaService.query<AwardDTO>(procurementProjectUrl);
          } else {
            if (numLot) {
              let procurementProjectUrl =
                this.configuration.AWARD_SERVICE_URL +
                '?contractFolderId=' +
                contractFolderId +
                '&lotsId=' +
                numLot +
                '&expand=expansionset:lotscompany';
              return this.plycaService.query<AwardDTO>(procurementProjectUrl);
            }
          }
          return of();
        }),
        map((resultAdjudicaciones: PaginationDTO<AwardDTO>) => {
          if (resultAdjudicaciones) {
            let awards: AwardDTO[];
            // devolvemos la adjudicacion del lote
            awards = resultAdjudicaciones.content;
            let _this = this as unknown as formElementComponent;
            if (awards) {
              awards.forEach((award: AwardDTO) => {
                // generar objeto company
                let companyToInvite = new CompanyToInviteDTO();
                companyToInvite.company = award.company;
                // TODO modificar for dto_path.push(companyToInvite)
                _this._addRow(companyToInvite);
              });
            }
          } else {
            // Se elimina en el caso de que haya precargadas antes
            model.breakdownLot.totalLots.companyToInvites = [];
            /*this.uiService.showMessage(
              this.plycaService.getServiceErrorMessage(
                this.translateService.instant(
                  'ProcurementProjectLot.notExistCompanyToInvite'
                )
              )
            );*/
          }
        }),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        })));
    } else {
      this.uiService.showMessage(
        this.translateService.instant(
          'ProcurementProjectLot.contractFolderIdCBAMRequired'
        )
      );
      return of();
    }
  }

  public openRequestMaterial(model: any) {
    return model.contractingSystem.originalContractingSystemID
      .requestedMaterial;
  }
  openCPVSelector() {
    let contextSearch = new SearchSettingDTOModal('', true);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    this.waitService.startWaiting();
    let ref = this.dialogService.open(searchCPVComponent, config);
    return ref.onClose;
  }

  public openProjectSelector() {
    let contextSearch = new SearchSettingDTOModal('ProcurementProject', true);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, documentClass => {
      let _this = this as unknown as formElementComponent;
      // TODO modificar for dto_path.push(documentClass)
      _this._addRow(documentClass);
    });
  }

  openCPVSelector2() {
    let contextSearch = new SearchSettingDTOModal('', true);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    this.waitService.startWaiting();
    let ref = this.dialogService.open(searchCPVComponent, config);
    this.subscribe(ref.onClose, cpv => {
      let _this = this as unknown as formElementComponent;
      // TODO modificar for dto_path.push(cpv)
      _this._addRow(cpv);
    });
  }

  newLot(model: any) {
    //    return new Promise(resolve => {
    //    return defer(() => {
    console.log('invocacion a newLot', model);
    let nuevoLote;
    if (!model) {
      nuevoLote = lodash.cloneDeep(model);
    } else {
      nuevoLote = new ProcurementProjectLotDTO();
    }
    nuevoLote.identifier = '' + generateRandomIdentifier();
    let lotNumber = 1;
    if (
      this.dossier &&
      this.dossier.breakdownLot &&
      this.dossier.breakdownLot.lots &&
      this.dossier.breakdownLot.lots.length > 0
    ) {
      lotNumber = this.dossier.breakdownLot.lots.length + 1;
    }
    nuevoLote.lotNumber = lotNumber;
    return nuevoLote;
  }

  removeLot(lot2Remove: ProcurementProjectLotDTO) {
    return new Promise(resolve => {
      // dossier.desglosableInfo;
      console.log('ELIMINANDO LOTE!!!!!!', lot2Remove);
      resolve(true);
    });
  }

  // Esta funcion de momento no se utiliza es para añadir filas vacías a la tabla de Empresas a Invitar
  addCompanyToInvite() {
    let _this = this as unknown as formElementComponent;
    let newRow: CompanyToInviteDTO = new CompanyToInviteDTO();
    // TODO modificar for dto_path.push(newRow)
    _this._addRow(newRow);
  }

  // Se llama a esta func. desde el boton verificar
  verifyDossier() {
    this.waitService.startWaiting('Validando expediente...');
    let model = this.viewModel2DTO();
    let validationContext = 'procurementProjects/validations/';
    // Si hay definido un grupo de validaciones asociado al paso  prevalece sobre la definición de validación asociado al formulario
    // Si hay definido un grupo de validaciones a la definición de formulario se especifica

    let validationContextGroupValidation = this.getContext(
      model.identifier !== undefined ? true : false
    );
    if (validationContextGroupValidation) {
      validationContext += validationContextGroupValidation;
    }
    console.log(
      'Validando el expediente,',
      model,
      ' con el grupo de validaciones ',
      validationContext
    );
    if (this.formPlycaRef) {
      this.formPlycaRef.deleteFormErrors();
    }
    this.subscribe(this.getValidateDossier(validationContext, model, true, true).pipe(
      finalize(() => this.waitService.cancelWaiting())
    ));
  }

  getValidateDossier(validationGroup: string, model?: any, message?: boolean, showMessageOK?: boolean): Observable<any> {
    console.log(
      'Validando formulario. Esquema utilizado:' + validationGroup,
      model
    );

    let messageOk: string;
    messageOk = this.translateService.instant('GenericDossier.validate.ok');
    if (message !== undefined && message !== null && message) {
      messageOk = this.translateService.instant('GenericDossier.validate.ok_correct');
    }

    return this.plycaService.validateDTO(validationGroup, model).pipe(
      tap(validations => {
        this.formPlycaRef.deleteFormErrors();
        if (getResultTypeDTOLevel(validations.body.result) !== getResultTypeDTOLevel(ResultTypeDTO.OK)) {
          this.formPlycaRef.manageFormException(validations.body);
        } else {
          if (showMessageOK !== undefined && showMessageOK != null && showMessageOK) {
            this.uiService.showMessage(
              messageOk,
              this.translateService.instant('General.info'),
              'helpStyle'
            );
          }
        }
      }),
      catchError((error: any) => {
        console.log('manageFormException 2', error);
        this.formPlycaRef.manageFormException(error);
        return throwError(error);
      })
    );
  }



  public exit(salirConAviso: boolean) {
    this.salirConAviso = salirConAviso;
    if (this.readonly) {
      this.route.navigate(['/dossiersView/EXP']);
    } else {
      if (this.dossier?.identifier) {
        let args: any;
        if (this.task) {
          args = { queryParams: { component: 'DOSSIER_ACTIONS' } };
        }
        this.route.navigate(['/dossierInfo/' + this.dossier?.identifier], args);
      } else {
        this.route.navigate(['/mainView/']);
      }
    }

  }

  public cancel(salirConAviso: boolean) {
    this.salirConAviso = salirConAviso;
    this.correctoPaso1 = true;
    this.uiService.routeBack();
  }

  public isCorrecStateLots(): boolean {
    // En el caso de que haya lotes
    if (this.lot === undefined) {

      // Se valida que el estado de todos los lotes sea cumplimentado
      if (
        this.dossier &&
        this.dossier.breakdownLot &&
        this.dossier.breakdownLot.lots &&
        this.dossier.breakdownLot.lots.length > 0
      ) {
        let incorrectStateLot: boolean = this.dossier.breakdownLot.lots?.filter(lotAux => lotAux.completed === 0).length > 0;
        // Si tiene lotes en estado en reparación el estado del lotes es incorrecto
        if (incorrectStateLot) {
          return false;
        }
      }
    }
    return true;
  }


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {

    // Mensaje por defecto
    let messageConf = this.translateService.instant('GenericDossier.notCompleted');

    // Sino el Paso 2 está OK, pero el Paso 1 no está correctamente cumplimentado
    // No afectaría a las FE de 1 Paso
    if (this.hasPreviousStep() !== undefined && this.hasPreviousStep() !== null && this.hasPreviousStep()) {
      if (this.correctoPaso1 !== undefined && !this.correctoPaso1) {
        this.salirConAviso = true;
        messageConf = this.translateService.instant('ProcurementProjectAYMAD.update.errorStep1');
      }
    }

    this.validaCierreVentana = this.salirConAviso || this.formPlycaRef?.formGroup?.dirty;
    // En el caso de que haya lotes
    if (this.lot === undefined) {
      // Se valida que el estado de todos los lotes sea cumplimentado
      if (!this.isCorrecStateLots()) {
        messageConf = this.translateService.instant('GenericDossier.notCompletedLot');
      }
    }

    if (this.task) {
      // Es una FE de dos Pasos que tiene errores en el Paso 1
      if (this.correctoPaso1 !== undefined && !this.correctoPaso1) {
        if (this.validaCierreVentana && !this.readonly) {
          return new Promise(resolve => {
            this.confirmationService.confirm({
              message: messageConf,
              acceptLabel: this.translateService.instant('GenericDossier.continueEditing'),
              rejectLabel: this.translateService.instant('GenericDossier.exit'),
              accept: () => resolve(false),
              reject: () => {
                this.waitService.startWaiting();
                this.subscribe(
                  this.taskService.unlockTask(this.getTask(), false),
                  undefined,
                  undefined,
                  () => {
                    this.validaCierreVentana = false;
                    this.isTaskUnlocked = true;
                    this.waitService.cancelWaiting();
                    resolve(true); // Permitir la navegación después de desbloquear la tarea
                  }
                );
              },
            });
          });

        } else {
          return true;
        }
      } else {
        return super.canDeactivate();
      }

    } else {
      if (this.validaCierreVentana && !this.readonly) {
        return new Promise(resolve => {
          this.confirmationService.confirm({
            // message: this.translateService.instant('General.discard.changes'),
            message: messageConf,
            acceptLabel: this.translateService.instant('GenericDossier.continueEditing'),
            rejectLabel: this.translateService.instant('GenericDossier.exit'),
            accept: () => resolve(false),
            reject: () => resolve(true)

          });
        });
      } else {
        return true;
      }
    }
  }

  // isProjectStartEnabled(): boolean {
  //   // solamente se habilita la opcion de tramitar si es el ultimo paso
  //   let stepCurrent = this.getCurrentStep();
  //   return (
  //     this.dossier &&
  //     stepCurrent.lastStep &&
  //     this.getStartProjectAction() != undefined
  //   );
  // }

  private getStartProjectAction(): ActionDTO {
    let startAction: ActionDTO;
    let dossier = this.dossier;
    let actions = dossier.availableActions;
    if (actions) {
      startAction = dossier.availableActions.actions.find(
        (action: ActionDTO) =>
          action.identifier === 'PROJECT_START' && action.enabled
      );
      this.dossier.availableActions = actions;
    }
    return startAction;
  }
  // configuracion del buscador de modelos
  public getCompanySearchFieldConfig(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'SEARCH';
    config.tooltipText = 'Seleccionar empresa adjudicataria';
    config.jsonField = 'company';
    config.description = 'Empresa adjudicataria:';
    config.autoSearch = false;
    config.idBuscador = 'com.nexusit.plyca.admin.interfaz.BuscadorEmpresasRIL';
    config.columnStyle = 'col-12';
    return config;
  }

  getFormIdFromTask() {
    let formId = undefined;
    if (this.task) {
      let variable = this.task.taskData.find(data => data.name === 'ID_FORMULARIO')
      if (variable && variable.value != '') {
        formId = variable.value;
      }
    }
    return formId;
  }



  public isActiveBaseContractNoRelated(model: any) {
    let activeBaseContractNoRelated =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isBaseContractNoRelated)
        ? model.context.configurations.isBaseContractNoRelated.value
        : false;

    if (activeBaseContractNoRelated) {
      return true;
    } else {
      return false;
    }

  }

  public setDefaultValueFrameworkAgreementCriteria(model: any) {

    // Si es un Acuerdo Marco, se establecen los valores por defecto
    let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
    let activeBaseContractNoRelated =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isBaseContractNoRelated)
        ? model.context.configurations.isBaseContractNoRelated.value
        : false;

    if (isCBAM && model.contractingSystem) {
      //Si esta activa la funcionalidad de contratos basados sin padre y esta marcado el check
      if (activeBaseContractNoRelated) {
        let baseContractNoRelated = model.contractingSystem && model.contractingSystem.baseContractNoRelated;
        model.contractingSystem.frameworkAgreementCriteria = baseContractNoRelated;
        model.contractingSystem.tenderBasedFrameworkAgreement = true;
      }
    }

  }

  public isEnabledTenderBasedFrameworkAgreement(model: any) {
    let enabled = true;

    if (model.classification && model.classification.complementarySystem) {
      let isCBAM = model.classification.complementarySystem.identifier == 'CBAM<>SISTCOMPLEMENTARIO';
      let baseContractNoRelated = false;

      // Si existe AM Padre o no
      baseContractNoRelated = model.contractingSystem && model.contractingSystem.baseContractNoRelated != undefined
        && model.contractingSystem.baseContractNoRelated != null && model.contractingSystem.baseContractNoRelated;
      // Precarga de datos de contratos basados
      if (isCBAM && !baseContractNoRelated) {
        // Se supone que ya esta cargado con los datos del AM padre el campo
        if (model.contractingSystem != null && model.contractingSystem.frameworkAgreementCriteria != null && !model.contractingSystem.frameworkAgreementCriteria) {
          enabled = false;
        }
      }
    }
    return enabled;
  }

  public isVisibleCategory(model: any) {
    // desglosable en lotes el acuerdo marco
    if (ProcurementProjectAYMADValidations.isComplementarySystem_CBAM_CSDA(model)) {
      if (model.contractingSystem.originalContractingSystemID != undefined && model.contractingSystem.originalContractingSystemID) {
        // Visible Unicamente si esta desglosado en lotes
        if (model.procurementProjectAM && model.procurementProjectAM.breakdownLot && model.procurementProjectAM.breakdownLot.apportioned) {
          return true;
        }
      }
    }
    return false;
  }


  isJsonFieldInForm(jsonField: string): boolean {
    if (this.formPlycaRef && this.formPlycaRef.groups && this.formPlycaRef.groups.length > 0)
      return this.formPlycaRef.groups.filter((group: FormGroupConfig) => {
        return group.group.fieldList.filter((field: FieldConfig) => field.jsonField === jsonField).length > 0;
      }).length > 0;
    else
      return false;
  }



  public getURLRequestedMaterial(contractFolderId: string, lotId: number) {
    let url =
      this.configuration.REQUEST_MATERIAL_SERVICE_URL +
      '?contractFolderId=' +
      contractFolderId +
      '&lotId=' +
      lotId;

    return url;
  }



  public getURLCompanyToInvite(contractFolderId: string, lotId: number) {
    let url =
      this.configuration.AWARD_SERVICE_URL +
      '?contractFolderId=' +
      contractFolderId +
      '&lotsId=' +
      lotId +
      '&expand=expansionset:lotscompany';
    return url;
  }

  public getURLCriteriaAward(contractFolderId: string, lotId: number) {
    let url =
      this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION +
      '?contractFolderId=' +
      contractFolderId +
      '&lotId=' +
      lotId +
      '&expand=expansionSet:basic_criteria';
    return url;
  }

  public setCriteriaAward(contractFolderId: string, lotId: number, model: any) {
    let url = this.getURLCriteriaAward(contractFolderId, lotId);

    this.subscribe(this.plycaService
      .query<ProcurementProjectLotDTO>(url),
      (result: PaginationDTO<ProcurementProjectLotDTO>) => {
        if (
          result &&
          result.content
        ) {
          model.breakdownLot.totalLots.selectionAwardCriteria = [];
          if (model.desglosableInfo['selectionAwardCriteria']) {
            model.desglosableInfo['selectionAwardCriteria'] = [];
          }
          result.content.forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
            (criteria: CriteriaDTO) => {
              criteria.identifier = undefined;
              model.desglosableInfo['selectionAwardCriteria'].push(
                criteria
              );
            }
          ));
        }
      },
      (error: any) => this.plycaErrorHandler.showServerError(error)
    );
    return model;
  }

  // Este metodo carga los Materiales Solicitados, Empresas a Invitar
  // y Criterios de Adjudicación del AM o SDA padre
  public loadDataAMSDA(model: any): Observable<any> {
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID
    ) {
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;
      //let categoria = model.contractingSystem.originalContractingSystemLotID;
      if (contractFolderId) {
        let loteId = null;
        // AM con lotes
        if (model.contractingSystem.originalContractingSystemLotID) {
          loteId = model.contractingSystem.originalContractingSystemLotID.lotId;
        } else {
          // AM sin lotes
          if (model.procurementProjectAM.breakdownLot.apportioned == false) {
            loteId = 0;
          }
        }

        if (loteId) {

          // Solo se tiene que hacer si ha elegido una categoria
          let confirmMessage = this.translateService.instant(
            'ProcurementProjectLot.loadCriterialAM'
          );

          this.uiService.showConfirmMessage({
            message: confirmMessage,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {

              // 1. Se cargan los materiales solicitados
              let urlRequestedMaterial =
                this.configuration.REQUEST_MATERIAL_SERVICE_URL +
                '?contractFolderId=' +
                contractFolderId +
                '&lotId=' +
                loteId;
              this.subscribe(this.plycaService.query<RequestMaterialDTO>(urlRequestedMaterial),
                (result: PaginationDTO<RequestMaterialDTO>) => {
                  if (
                    result &&
                    result.content
                  ) {
                    model.breakdownLot.totalLots.requestedMaterial = [];
                    if (model.desglosableInfo['requestedMaterial']) {
                      model.desglosableInfo['requestedMaterial'] = [];
                    }
                    result.content.forEach(
                      (material: RequestMaterialDTO) => {
                        material.lot = null;
                        material.identifier = undefined;
                        model.desglosableInfo['requestedMaterial'].push(
                          material
                        );
                      }
                    );
                  }
                },
                (error: any) => this.plycaErrorHandler.showServerError(error)
              );

              // 2. Se cargan las empresas a invitar
              let urlCompanyToInvite =
                this.configuration.AWARD_SERVICE_URL +
                '?contractFolderId=' +
                contractFolderId;

              if (loteId != 0) {// Se le pasa el identificador del lote
                urlCompanyToInvite =
                  this.configuration.AWARD_SERVICE_URL +
                  '?contractFolderId=' +
                  contractFolderId +
                  '&lotsId=' +
                  loteId +
                  '&expand=expansionset:lotscompany';
              }

              this.subscribe(this.plycaService.query<AwardDTO>(urlCompanyToInvite),
                (resultAdjudicaciones: PaginationDTO<AwardDTO>) => {

                  if (
                    resultAdjudicaciones &&
                    resultAdjudicaciones.content
                  ) {
                    let companiesToInvites = new Array<CompanyToInviteDTO>();
                    resultAdjudicaciones.content.forEach((award: AwardDTO) => {
                      // generar objeto company
                      let companyToInvite = new CompanyToInviteDTO();
                      companyToInvite.company = award.company;
                      companiesToInvites.push(companyToInvite);
                    });
                    model.breakdownLot.totalLots.companyToInvites = companiesToInvites;
                  }
                },
                (error: any) => this.plycaErrorHandler.showServerError(error)
              );

              // 3. Se cargan los criterios de ajudicacion
              let urlAwardCriteria =
                this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION +
                '?contractFolderId=' +
                contractFolderId +
                '&lotId=' +
                loteId +
                '&expand=expansionSet:basic_criteria';

              this.subscribe(this.plycaService
                .query<ProcurementProjectLotDTO>(urlAwardCriteria),
                (result: PaginationDTO<ProcurementProjectLotDTO>) => {
                  if (
                    result &&
                    result.content
                  ) {
                    model.breakdownLot.totalLots.selectionAwardCriteria = [];
                    if (model.desglosableInfo['selectionAwardCriteria']) {
                      model.desglosableInfo['selectionAwardCriteria'] = [];
                    }
                    result.content.filter((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria && lot.selectionAwardCriteria.length > 0
                    ).forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                      //result.content.forEach((lot: ProcurementProjectLotDTO) => lot.selectionAwardCriteria.forEach(
                      (criteria: CriteriaDTO) => {
                        criteria.identifier = undefined;
                        model.desglosableInfo['selectionAwardCriteria'].push(
                          criteria
                        );
                      }
                    ));
                  }
                },
                (error: any) => this.plycaErrorHandler.showServerError(error)
              );
              return model;
            }, reject: () => {
              console.log('NO SE CARGAN LOS DATOS EXPEDIENTE RELACIONADO (AM, SDA)');
            }
          });

        }
      }
    }
    return model;
  }

  ////  FUNCIONES PARA GOBERNANZA /////

  // Valor del campo Directiva de aplicacion
  public valueEUDirective(model: any) {
    if (ProcurementProjectAYMADValidations.isMinorContract(model)) {
      model.euDirective = {};
      model.euDirective.identifier = 'N/A<>DIRECTIVA_UE';
    } else {
      if (model.applicableLegislation.identifier == '04<>VERSIONNORMATIVA') {
        if (ProcurementProjectAYMADValidations.isServicesConcession(model) || ProcurementProjectAYMADValidations.isWorkConcession(model)) {
          model.euDirective = {};
          model.euDirective.identifier = '2014/23/EU<>DIRECTIVA_UE';
        } else {
          model.euDirective = {};
          model.euDirective.identifier = '2014/24/EU<>DIRECTIVA_UE';
        }
      }
    }
  }

  public valueNumLicitableLots(model: any) {
    if (model.breakdownLot && model.breakdownLot.apportioned && model.breakdownLot.tenderAllLots) {
      //this.setActionButtons();
      model.breakdownLot.numLicitableLots = null;
    } else {
      //this.setActionButtons();
      model.breakdownLot.numLicitableLots;
    }
    // La visibilidad de los botones, depende de si tiene lotes o no

  }
  public clearLotTotalTaxes(model: any) {
    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier == '0<>TIPO_IMPUESTO');

    // Si es un expediente sin IVA, Se limpia el IVA DE todos los lotes
    if (noTax) {
      let elements = [];
      if (model.breakdownLot && model.breakdownLot.lots && model.breakdownLot.lots.length > 0) {
        model.breakdownLot.lots.forEach(item => {
          item.budget.totalTaxes = 0;
        });
      }
    }
  }

  // copia parcial de lote
  private showpartialCopyOptions(): void {
    this.showPartialLotCopy = true;
    this.resetCheckboxes();
  }

  // Función para limpiar las opciones seleccionadas
  public resetCheckboxes() {
    this.selectedCopyOptions = [];
  }

  public executePartialCopy(): void {
    this.uiService.showConfirmMessage({
      message: 'Se van a copiar los datos seleccionados en el lote ' + this.lot.lotNumber + '.</br> ¿Desea continuar con la operación?',
      header: this.translateService.instant('General.confirmtext'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // 1. consultar datos del lote a copiar
        this.subscribe(this.getProcurementProjectLot('' + this.selectedLotToCopy?.identifier).pipe(
          catchError((error: any) => {
            this.manageActionError(error, false);
            return throwError(error);
          }),
          tap((selectedLot: ProcurementProjectLotDTO) => {
            // 2. copiar apartados seleccionados
            this.procurementProjectAYMADUtils.copyPartialLotInfo(selectedLot, this.lot, this.selectedCopyOptions);
            this.showPartialLotCopy = false;
            this.formPlycaRef.updateView();
            this.resetCheckboxes();
          })
        ));
      },
      reject: () => {
        this.showPartialLotCopy = false;
        this.resetCheckboxes();
      }
    });
  }

  public executeHelpPartialCopy(option: PartialCopyOptions): void {

    this.subscribe(this.getProcurementProjectLot('' + this.selectedLotToCopy?.identifier).pipe(
      catchError((error: any) => {
        this.manageActionError(error, false);
        return throwError(error);
      }),
      tap((selectedLot: ProcurementProjectLotDTO) => {
        // 2. copiar apartados seleccionados
        this.helpData(option, selectedLot.parent);
      })
    ));
  }


  public helpData(option: PartialCopyOptions, project: ProcurementProjectDTO) {

    // Tabla Medios de solvencia
    if (option === PartialCopyOptions.SOLVENCY) {
      this.showHelp(this.translateService.instant('ProcurementProjectAYMAD.Lot.helOptions.SOLVENCY'));
    }
    if (option === PartialCopyOptions.CANDIDATE_CRITERIA) {
      this.showHelp(this.translateService.instant('ProcurementProjectAYMAD.Lot.helOptions.CANDIDATE_CRITERIA'));
    }
    if (option === PartialCopyOptions.AWARD_CRITERIA) {
      this.showHelp(this.translateService.instant('ProcurementProjectAYMAD.Lot.helOptions.AWARD_CRITERIA'));
    }
    if (option === PartialCopyOptions.OUTSOURCING) {
      if (!project.exp_Subcontratacion_2023) {
        this.showHelp(this.translateService.instant('ProcurementProjectAYMAD.Lot.helOptions.OUTSOURCING'));
      } else {
        this.showHelp(this.translateService.instant('ProcurementProjectAYMAD.Lot.helOptions.OUTSOURCING_2023'));
      }
    }
    if (option === PartialCopyOptions.DELAY_PENALTIES) {
      this.showHelp(this.translateService.instant('ProcurementProjectAYMAD.Lot.helOptions.DELAY_PENALTIES'));
    }
    if (option === PartialCopyOptions.OTHER_PENALTIES) {
      this.showHelp(this.translateService.instant('ProcurementProjectAYMAD.Lot.helOptions.OTHER_PENALTIES'));
    }
  }

  showHelp(helpText: string) {

    this.uiService.showMessage(
      helpText,
      this.translateService.instant('General.info'),
      'helpStyle'
    );
  }

  // Copia de Lote
  public copyLot(model: ProcurementProjectLotDTO) {

    if (model.completed === undefined || model.completed === null) {
      this.confirmationService.confirm({
        message: 'El lote que intenta copiar no tiene datos',
        acceptLabel: 'Aceptar',
        rejectVisible: false,
        accept: () => {
          // No hace nada...
        },
      });
    } else {
      let params;
      params = {
        'parentDoc.division.project.identifier': model.parent.identifier,
        'parentDoc.documentClass.identifier': '00002',
        'parentDoc.orderNumber': '0',
        'lot.lotId': model.lotId,
        'page': '0',
        'size': '1'
      };

      this.subscribe(
        this.plycaService.query<any>(this.configuration.UNITPRICES_SERVICE_URL, params).pipe(
          finalize(() => {
            this.loaded = true;
            this.waitService.cancelWaiting();
          })
        ),
        results => {
          let textMessage = 'Va a crear un nuevo lote con los datos del lote ' + model.lotNumber + '.';
          if (results && results.content) {
            textMessage = textMessage + '</br>El lote a copiar contiene Precios Unitarios, los cuales NO se van a copiar en el nuevo lote creado. ';
          }

          // Agregar mensaje de confirmación adicional
          textMessage = textMessage + '¿Desea continuar?';

          // Mostrar la confirmación
          this.confirmationService.confirm({
            message: textMessage,
            acceptLabel: 'Aceptar',
            accept: () => {
              this.subscribe(
                this.saveProjectIfNecessary(undefined, false).pipe(
                  switchMap(() => {
                    this.waitService.startWaiting('Copiando lote....');
                    return this.plycaService.runActionByName('AYMAD_CLONE_PROJECTLOT', 'TARGET=' + model.identifier);
                  }),
                  switchMap((result: ActionResultDTO) => {
                    if (result.identifier === ResultTypeDTO.OK) {
                      this.waitService.startWaiting('Consultando expediente ...');
                      // Actualizar expediente y sus validaciones
                      return this.plycaService.getProcurementProject(this.dossierId, '?expand=' + this.getDossierExpansion());
                    } else {
                      return throwError('Error al copiar lote');
                    }
                  }),
                  switchMap((updatedProject: ProcurementProjectDTO) => {
                    // Actualizar modelo
                    this.updateProjectModel(updatedProject);
                    // Se llama de nuevo a las validaciones, cuando se realiza la copia de lote
                    return this.validateProject(true).pipe(
                      map(() => updatedProject)
                    );
                  }),
                  tap((updatedProject: ProcurementProjectDTO) => {
                    this.waitService.cancelWaiting();
                    // Puedes realizar acciones adicionales después de validar el proyecto
                    // ...
                  }),
                  catchError((error: any) => {
                    this.plycaErrorHandler.showServerError(error);
                    return throwError(error);
                  })
                )
              );
            },
            reject: () => {
              console.log('No hace nada...');
            }
          });

        }
      );
    }
  }


  /*public copyLot(model: ProcurementProjectLotDTO) {

    if (model.completed === undefined || model.completed === null) {
      this.confirmationService.confirm({
        message: 'El lote que intenta copiar no tiene datos',
        acceptLabel: 'Aceptar',
        rejectVisible: false,
        accept: () => {
          // No hace nada...
        },
      });
    } else {
      let textMessage = 'Va a crear un nuevo lote con los datos del lote ' + model.lotNumber + '.';
      if (model?.budget?.unitPrice !== undefined && model?.budget?.unitPrice.length > 0) {
        textMessage = textMessage + '</br>El lote a copiar contiene Precios Unitarios, los cuales NO se van a copiar en el nuevo lote creado. ';
      }
      textMessage = textMessage + '¿Desea continuar?';
      this.confirmationService.confirm({
        message: textMessage,
        acceptLabel: 'Aceptar',
        accept: () => {
          this.subscribe(
            this.saveProjectIfNecessary(undefined, false).pipe(
              switchMap(() => {
                this.waitService.startWaiting('Copiando lote....');
                return this.plycaService.runActionByName('AYMAD_CLONE_PROJECTLOT', 'TARGET=' + model.identifier);
              }),
              switchMap((result: ActionResultDTO) => {
                if (result.identifier === ResultTypeDTO.OK) {
                  this.waitService.startWaiting('Consultando expediente ...');
                  // actualizar expediente y sus validaciones
                  return this.plycaService.getProcurementProject(this.dossierId, '?expand=' + this.getDossierExpansion());
                } else {
                  return throwError('Error al copiar lote');
                }
              }),
              switchMap((updatedProject: ProcurementProjectDTO) => {
                // actualizar modelo
                this.updateProjectModel(updatedProject);
                // Se llama de nuevo a las validaciones, cuando se realiza la copia de lote
                // En el caso de que haya 1 solo lote, se lanza la validación de que es obligatorio introducir más  de 1 lote,
                // para que desaparezca a la vuelta de copiar el lote, la validacion ya que ahora tiene dos lotes y no debe mostrarse
                // Asi como el resto de vaidaciones asociadas que tienen que ver con el número de lotes introducidos
                return this.validateProject(true).pipe(
                  map(() => updatedProject)
                );
              }),
              tap((updatedProject: ProcurementProjectDTO) => {
                this.waitService.cancelWaiting();
                // Puedes realizar acciones adicionales después de validar el proyecto
                // ...
              }),
              catchError((error: any) => {
                this.plycaErrorHandler.showServerError(error);
                return throwError(error);
              })
            )
          );
        },
        reject: () => {
          console.log('No hace nada...');
        }
      });
    }
  }*/

  private getLotMenuItems(): MenuItem[] {
    let lotMenuItems = new Array<MenuItem>();
    if (this.dossier?.breakdownLot?.lots) {
      this.dossier?.breakdownLot?.lots.forEach((lot: ProcurementProjectLotDTO) => {
        lotMenuItems.push({
          //label: 'Lote: ' + lot.lotNumber + ' - ' + lot.description,
          label: 'Lote: ' + lot.lotNumber,
          icon: 'fa fa-chevron-right',
          command: (event: { originalEvent: Event, item: MenuItem }) => {
            this.showGoToLotSelection = false;
            this.editLot(lot);
          }
        });
      })
    }
    return lotMenuItems;
  }

  private editZeroLot() {
    this.editLotNumber(0);
  }

  private editLotNumber(lotNumber: number) {
    const zeroLot = new ProcurementProjectLotDTO();
    zeroLot.lotNumber = lotNumber;
    this.editLot(zeroLot);
  }

  public editLot(model: any) {
    let newStep = 1;

    /*"editLot": {
      "messageLotZero": "NO es posible editar los datos del paso II, hasta que corrija los errores que se muestran con la letra en rojo",
      "messageLot": "NO es posible editar los datos del lote, hasta que corrija los errores que se muestran con la letra en rojo",
      "messageReadOnly_LotZero": "NO es posible visualizar los datos del paso II",
      "messageReadOnly_Lot": "NO es posible visualizar los datos del lote"
    }*/

    let message = this.translateService.instant('ProcurementProjectAYMAD.editLot.messageLotZero');
    if (model.lotNumber && model.lotNumber !== 0) {
      message = this.translateService.instant('ProcurementProjectAYMAD.editLot.messageLot');
    }
    let messageReadOnly = this.translateService.instant('ProcurementProjectAYMAD.editLot.messageReadOnly_LotZero');
    if (model.lotNumber && model.lotNumber !== 0) {
      messageReadOnly = this.translateService.instant('ProcurementProjectAYMAD.editLot.messageReadOnly_Lot');
    }

    const lotNumber = model.lotNumber;
    if (!lodash.isNumber(lotNumber)) {
      this.uiService.showMessage('Debe introducir el número de lote');
      throw new Error('Debe introducir el número de lote');
    }
    console.log('Invocación a breakdownLot de PROCUREMENTPROJECTAYMADCOMPONENT', model);
    console.log('Desglose del lote: ', model.lotId);
    console.log('new Index: ' + newStep);
    let saveObs: Observable<any>;

    if (this.readonly) {
      saveObs = of({});
    } else if (this.currentStep === 0) {
      saveObs = this.saveProjectIfNecessary();
    } else {
      saveObs = this.saveLotIfNecessary();
    }

    this.subscribe(saveObs.pipe(
      catchError((error: any) => {
        if (this.readonly) {
          this.uiService.showMessage(messageReadOnly, 'Error', 'errorStyle');
        } else {
          this.uiService.showMessage(message, 'Error', 'errorStyle');
        }
        return throwError(error);
      }),
      switchMap(() => {
        // buscar el identificador del lote a editar entre los lotes del expediente actualizado
        let lotObs: Observable<any>;
        let lot2Edit: ProcurementProjectLotDTO;
        if (lotNumber === 0) {
          lot2Edit = this.dossier.breakdownLot.totalLots;
        } else {
          lot2Edit = this.dossier.breakdownLot.lots.find((lot: ProcurementProjectLotDTO) => lot.lotNumber === lotNumber);
        }
        if (this.stepDefinition.steps.length === 1) {
          // no consultamos a servidor la expansion del lote porque la hemos traido con el expediente (1 paso)
          lotObs = of(lot2Edit);
        } else {
          // consultar lote con expansion porque no la hemos traido con el expediente (2 pasos)
          lotObs = this.getProcurementProjectLot(lot2Edit.identifier);
        }
        return lotObs;
      }),
      tap(() => {
        this.currentStep = newStep;
      }),
      switchMap((updatedLot: ProcurementProjectLotDTO) =>
        this.getAuxProperties(updatedLot).pipe(
          map((result: any[]) => updatedLot)
        )
      ),
      switchMap((updatedLot: ProcurementProjectLotDTO) => this.processLotForm(updatedLot)),
      tap((formLoaded: boolean) => {
        if (formLoaded) {
          this.lotModified = false;
          /*if (lotNumber === 0) {
            this.setHeader('PASO II: RESTO DE DATOS DEL EXPEDIENTE');
          } else {
            this.setHeader('PASO II: DATOS DEL LOTE ' + this.lot?.lotNumber + ' - ' + this.lot?.description);
          }*/
          this.setHeader(this.getHeaderFormStep2(this.lot))

          // actualizar lista de lotes que pueden usarse como copia parcial
          this.lotsToCopy = this.dossier.breakdownLot.lots?.filter(lotAux => lotAux.identifier !== this.lot.identifier);
          // establecer el primer valor como seleccionado
          this.selectedLotToCopy = this.lotsToCopy[0];
        }
      }),
      finalize(() => this.waitService.cancelWaiting())
    ));
  }

  private saveLotIfNecessary(validate = false): Observable<ValidationResultDTO> {
    let obs: Observable<ValidationResultDTO>;
    if (this.formPlycaRef.formGroup.dirty) {
      this.waitService.startWaiting(this.translateService.instant('GenericDossier.changing'));
      // existen cambios sin guardar
      obs = this.insertOrUpdateLot().pipe(
        map((projectLot: ProcurementProjectLotDTO) => projectLot?.validationResult)
      );
    } else if (validate) {
      this.waitService.startWaiting('Validando datos...');
      obs = this.validateLot(true);
    } else {
      obs = of(new ValidationResultDTO(ResultTypeDTO.OK));
    }
    return obs;
  }

  private saveProjectIfNecessary(additionalQueryExpansion: string = undefined, updateModel = true,
    showErrors = false): Observable<ValidationResultDTO> {
    let obs: Observable<any>;

    // Si viene del botón de volver de lotes
    /*if (this.saveAlways) {
      this.formPlycaRef.markAsDirty();
      this.saveAlways = undefined;
    }*/

    // De momento que lo haga siempre hasta que se solucione el problema, cuando viene desde tarea
    this.formPlycaRef.markAsDirty();

    if (this.formPlycaRef.formGroup.dirty) {
      this.waitService.startWaiting(this.translateService.instant('GenericDossier.changing'));
      // existen cambios sin guardar
      obs = this.insertOrUpdateProject(additionalQueryExpansion, updateModel).pipe(
        map((project: ProcurementProjectDTO) => project?.validationResult)
      );
    } else {
      this.waitService.startWaiting('Validando datos del expediente...');
      // validar expediente para ver si se puede continuar
      /*obs = this.validateProject(showErrors).pipe(
        switchMap(() => {
          this.waitService.startWaiting('Consultando expediente ...');
          const queryExpansion = '?expand=' + this.getDossierExpansion() +
            ((additionalQueryExpansion) ? ',' + additionalQueryExpansion : '');
          return this.plycaService.getProcurementProject(this.dossier?.identifier, queryExpansion);
        })
      );*/
      obs = this.validateProject(showErrors);
      // Si está OK y el estado de todos los lotes es OK y el estado del documento esta en reparación
      // Se podría hacer un cambio de estado a cumplimentado

    }
    return obs;
    /*.pipe(
      map((project: ProcurementProjectDTO) => project.validationResult)
    );*/
  }

  // Desglosar Lote
  // private editLot_old(newStep: number, model: any) {
  //   // 1. Se verifica, si existe el expediente
  //   // 1.1 Sino existe el expediente, se graba el expediente y los lotes que existen por pantalla
  //   // 1.2 Se muestran las validaciones de los campos que son obligatorios para poder desglosar el lote
  //   // 1.3 Si las validaciones estan OK, se abre el json de edición del lote
  //   this.lot = model;

  //   if (this.hasNextStep()) {
  //     newStep = this.getCurrentStep().value + 1;
  //   }

  //   console.log('Invocación a breakdownLot de PROCUREMENTPROJECTAYMADCOMPONENT', model);
  //   console.log('Desglose del lote: ', model.lotNumber);
  //   console.log('new Index: ' + newStep);

  //   this.waitService.startWaiting();

  //   // Se verifica si hay que grabar el expediente y los lotes inicicialmente
  //   this.subscribe(this.saveDossierLotTable(newStep).pipe(finalize(
  //     () => {
  //       this.subscribe(this.helpService.showContextHelpObservable(HelpType.CREATE_DOSSIER).pipe(

  //         finalize(() => {

  //           console.log('Componente cargado');
  //           if (this.formPlycaRef && !this.formPlycaRef.completed) {
  //             this.subscribe(this.formPlycaRef.getCompleted().pipe(
  //               finalize(() => {
  //                 this.waitService.cancelWaiting();
  //                 this.loaded = true;

  //               })))
  //           } else {
  //             this.waitService.cancelWaiting();
  //             this.loaded = true;
  //           }
  //         }

  //         )));
  //       console.log('Guardado y al siguiente paso:');
  //     }





  // //   )));

  //   /*this.waitService.startWaiting();
  //   this.subscribe(this.saveLot(model).pipe(finalize(() => {
  //     this.waitService.cancelWaiting();
  //     this.loaded = true;
  //   })),
  //     data => {

  //       // this.loading.next(new LoadingInfo(false));
  //       if (this.task && !this.isStatelessTask()) {
  //         let stepCurrent = this.getCurrentStep();
  //         if (stepCurrent.lastStep && data.isValidatedOk) {
  //           this.waitService.startWaiting('Procesando los datos de la tarea ...');
  //           this.procesandoTarea = true;
  //           this.processTask();
  //         }
  //       }
  //     }
  //   );*/
  // }



  // saveDossierLotTable(newStep?: number): Observable<SaveDossierData> {
  //   this.waitService.startWaiting('Validando los datos del expediente ...');
  //   // Se establece el LISTADOCID
  //   if (!this.dossier.documentClass) {
  //     // if (this.model) {
  //     //   this.dossier.documentClass = {
  //     //     identifier: this.appConfig.getValue('dossierModel.documentClass'),
  //     //     abbreviation: 'EXPMODELO'
  //     //   } as DocumentClassDTO;
  //     // } else {
  //     this.dossier.documentClass = {
  //       identifier: '00000'
  //     } as DocumentClassDTO;
  //     // }
  //   }
  //   // VALIDATE -->
  //   let model = this.viewModel2DTO();
  //   let validationContext = 'procurementProjects/validations/';

  //   // si hay definido un grupo de validaciones asociado al paso  prevalece sobre la definición de validación asociado al formulario
  //   // si hay definido un grupo de validaciones a la definición de formulario se especifica

  //   let validationContextGroupValidation = this.getContext(
  //     model.identifier !== undefined ? true : false
  //   );
  //   if (validationContextGroupValidation) {
  //     validationContext += validationContextGroupValidation;
  //   }
  //   console.log(
  //     'VALIDANDO MODELO',
  //     model,
  //     ' con el grupo de validaciones ',
  //     validationContext
  //   );
  //   // Se validan los campos introducidos
  //   return this.formPlycaRef.getValidateObservable(validationContext, model).pipe(
  //     switchMap(validations => {

  //       // Se muestran los errores de validación
  //       console.log('Validación completada.');

  //       let validationErrors: boolean =
  //         validations.body.errors && validations.body.errors.filter(error => error.result !== "WARNING").length > 0;

  //       // Se guardan los datos del expediente y se muestra el diálog de espera de actualización
  //       let config: DynamicDialogConfig = {
  //         header: '',
  //         closeOnEscape: false,
  //         showHeader: false,
  //         width: '50%',
  //         style: { overflow: 'scroll', 'max-height': '80%' }
  //       };

  //       config['dossier'] = this.viewModel2DTO();
  //       config['task'] = this.task;

  //       config['validationContext'] = this.getContext(
  //         config['dossier'].identifier != undefined ? true : false
  //       );
  //       let stepCurrent = this.getCurrentStep();
  //       config['lastStep'] = stepCurrent.lastStep;
  //       if (newStep !== undefined && stepCurrent.value !== newStep) {
  //         config['stepChange'] = true;
  //       }

  //       // En el caso de que se esté desglosando un lote, se le pasa el lote que se está desglosando
  //       if (this.lot != undefined && this.lot) {
  //         config['lot'] = this.lot;
  //       }
  //       // Se llama desde el paso 1 de la tabla de lotes, se está grabando el expediente
  //       config['saveLotOnly'] = false;


  //       const ref = this.dialogService.open(saveDossierPopupAYMADComponent, config);

  //       return ref.onClose.pipe(
  //         this.onClosePopup(validationErrors, newStep, validationContext),

  //         finalize(() => {
  //           this.loaded = true;
  //           this.waitService.cancelWaiting();
  //         }));

  //       // <-- VALIDATE
  //     }));
  // }



  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.title = 'PASO II: DATOS DEL LOTE 1 - LOTE 1';
    headerInfo.titleIcon = 'fas fa-hand-holding';
    return headerInfo;
  }

  private saveLotObservable(cancelWait = true): Observable<any> {
    this.waitService.startWaiting(this.translateService.instant('GenericDossier.changing'));
    return this.insertOrUpdateLot().pipe(
      tap(() => {
        let message = '';
        if (this.lot.lotId == 0) {
          // message = this.translateService.instant('ProcurementProjectAYMAD.update.ok');
          message = this.translateService.instant('ProcurementProjectAYMAD.update.ok', {
            identifier: this.getDossierId(this.dossier)
          });
        } else {
          message = this.translateService.instant('ProcurementProjectAYMAD.update.okLot', {
            identifier: this.lot.lotNumber
          });
        }

        this.uiService.showSuccess(message, this.translateService.instant('General.info'), 'success');
      }),
      finalize(() => {
        if (cancelWait) {
          this.waitService.cancelWaiting();
        }
      })
    );
  }

  private viewModelLot2DTO(): ProcurementProjectLotDTO {
    // trabajamos con una copia del objeto
    let tmpLot: ProcurementProjectLotDTO;
    tmpLot = lodash.cloneDeep(this.lot);
    console.log('antes de limpiar', this.lot, tmpLot);

    tmpLot.parent = this.viewModel2DTO();
    tmpLot.parent.breakdownLot.lots = null;
    tmpLot.parent.breakdownLot.totalLots = null;

    // limpiar variables de apoyo de tablas
    tmpLot = JSON.parse(
      JSON.stringify(tmpLot, (k, v) => (k === '_parent' ? undefined : v))
    );
    console.log('despues de limpiar', this.lot, tmpLot);
    tmpLot.validationResult = undefined;
    return tmpLot;
  }


  private processLotForm(_lot: ProcurementProjectLotDTO): Observable<any> {
    console.log('processDossierForm');

    //etiquetas
    this.subscribe(
      this.helpService.showContextHelpObservable(HelpType.CREATE_LOT));

    this.loaded = false;
    this.lot = _lot;
    //this.dossierId = this.dossier.identifier;

    /*if (this.dossier.documentClass) {
      this.model =
        this.dossier.documentClass.identifier === this.appConfig.getValue('dossierModel.documentClass');
    }*/
    //Si tiene parametros establece el valor de los mismos
    /*if (this.isNewDossier && this.stepDefinition.default) {
      lodash.merge(this.dossier, this.stepDefinition.default);
    }*/

    // establecer el identificador del formulario
    //this.dossier.formId = '' + this.stepDefinition.identifier;
    // this.dto2ViewModel(this.dossier);


    console.log('llamada a loadForms');
    // this.loaded = true;
    return this.loadForms(this.currentStep).pipe(
      tap(() => this.loaded = true)
    );

  }

  // FUNCIONES APARIENCIA PARA AYUMAD //

  public valueBudgetTotalTaxesLot(model: any) {
    // Funcion para el paso 2 cuando hay desglose de lotes

    // Exento de IVA
    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier == '0<>TIPO_IMPUESTO');

    let isSeveralTaxes = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier == '998<>TIPO_IMPUESTO');

    let taxIncluded = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier == '1<>TIPO_IMPUESTO');

    if (model.budget && model.budget.taxType && model.budget.taxType.identifier) {
      if (model.budget.taxType.properties != undefined) {
        let percentage = model.budget.taxType.properties.PORCENTAJE;
        // Exento de IVA
        if (noTax) {
          model.budget.totalTaxes = 0;
          model.budget.lotManualCalculation = false;
          // Es necesario borrar el IVA DE todos los lotes
        } else {
          // Distinto de Varios Tipos, y de IVAincluido
          if (!isSeveralTaxes && !taxIncluded) {
            if (percentage != undefined && percentage != 0 && model.budget.amountExcludingTaxes != undefined && model.budget.amountExcludingTaxes !== null) {
              // Solo se realiza el calculo, si es distinto de calculo manual
              if ((model.budget.lotManualCalculation == undefined) || (model.budget.lotManualCalculation != undefined && !model.budget.lotManualCalculation)) {
                //model.budget.totalTaxes = this.roundDecimals.bind(((model.budget.amountExcludingTaxes * percentage) / 100), 2);
                model.budget.totalTaxes = ((model.budget.amountExcludingTaxes * percentage) / 100);
              }
            }
          }
          else {
            // Calculo Manual, se establece "No" por defecto
            model.budget.lotManualCalculation = false;
          }
        }
      }
    } else {
      // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
      // model.budget.amountExcludingTaxes = 0;
      model.budget.totalTaxes = 0;
      model.budget.totalAmount = 0;
    }
  }

  // Se carga el email , en el caso de que exista para la Empresa a Invitar
  public setEmailCompanyToInvite(model: any) {
    // En el caso de que tenga email la empresa, se carga por defecto
    if (model.company != undefined && model?.company?.email != undefined && model?.company?.email) {
      model.email = model.company.email;
    }
  }

  public valueChangeFinancingSuspCond(model: any) {
    if (model.characteristicsContractObject && model.characteristicsContractObject.financingSuspCond) {
      model.classification.expenseCode = false;
    }
  }

  // Limpieza del desplegable de SubTipo
  public cleanSubtype(model: any, evt: any) {
    if ((evt.newValue && evt.newValue.identifier && evt.oldValue && evt.oldValue.identifier) // Los dos tienen identificador
      || (evt.newValue === undefined)) //Se ha limpiado el campo.)
    {

      if (evt.newValue === undefined || (evt.newValue.identifier != evt.oldValue.identifier)) {
        // Se limpia el desplegable de Subtipo
        model.classification.subTypeCode = {};
      }
    }
  }

  // FE Contratación
  // Si se modifica el valor del tipo de Expediente, se limpia el valor de los desplegables
  public evtChangeTypeCode(model: any, evt: any) {
    if (evt.newValue === undefined || (evt.newValue && evt.newValue.identifier && evt.oldValue && evt.oldValue.identifier)) {
      if (evt.newValue === undefined || (evt.newValue.identifier !== evt.oldValue.identifier)) {
        // Se limpia el desplegable de Subtipo
        model.classification.subTypeCode = {};
        // Se limpia el desplegable de Justificación Negociados
        model.classification.processJustificationNegotiated = {};

      }
      // Se limpia el desplegable de Regulación Armonizada, si se cambia a Servicios
      if (evt.newValue !== undefined && evt.newValue && evt.newValue.identifier && evt.oldValue !== undefined && evt.oldValue && evt.oldValue.identifier) {
        if (evt.oldValue.identifier !== '04<>TIPOEXPTE' && evt.newValue.identifier == '04<>TIPOEXPTE') {
          model.classification.harmonizedRegulation = null;
        }
      }
    }
  }

  // Si se cambia el tipo de procedimiento, se limpia el valor del desplegable Justificación de los negociados
  public evtChangeType(model: any, evt: any) {
    let type: string;
    let t: string;
    let valor: '';
    if (evt.newValue && evt.newValue.identifier && evt.oldValue && evt.oldValue.identifier) {
      if (evt.newValue.identifier != evt.oldValue.identifier) {
        // Se limpia el desplegable de Justificación Negociados
        model.classification.processJustificationNegotiated = {};

        if (ProcurementProjectAYMADValidations.isTypeMode(model, 'N')) {
          model.classification.awardMethod = {
            identifier: 'P<>FORMASADJUDICACION',
            description: 'Pluralidad de Criterios'
          };
        } else {
          model.classification.awardMethod = undefined;
        }
      }
    }
    if (model.type) {
      t = model.type.identifier;
      // Selecciona el identificador
      let type = t.substr(0, t.indexOf('<'));

      // Si el tipo de procedimiento es uno de los que dan valor 1 al campo Licitación Electrónica
      if (model?.context?.configurations?.typeProcSubmissionMethodCode) {
        valor = model?.context?.configurations?.typeProcSubmissionMethodCode.value;
        if (valor.includes(type)) {
          model.classification.submissionMethodCode = true;
        } else {
          model.classification.submissionMethodCode = null;
        }
      }
      // Si es un Negociado se modificado el campo pluraridad de Criterios

    } else {
      model.classification.submissionMethodCode = null;
    }

    let typeCode = (model?.classification?.typeCode && model?.classification?.typeCode?.identifier) ?
      model?.classification?.typeCode.identifier : undefined;
    let isServices = typeCode !== undefined && model?.classification.typeCode.identifier === '04<>TIPOEXPTE';


    // Se limpia el desplegable de Regulación Armonizada, si se cambia
    if (isServices) {
      if (evt.newValue !== undefined && evt.newValue && evt.newValue.identifier && evt.oldValue !== undefined && evt.oldValue && evt.oldValue.identifier) {
        if (evt.oldValue.identifier === 'AS<>PROCEDIMIENTOSCONTRA' || evt.oldValue.identifier === 'ASA<>PROCEDIMIENTOSCONTRA') {
          if (evt.newValue.identifier !== 'AS<>PROCEDIMIENTOSCONTRA' && evt.newValue.identifier !== 'ASA<>PROCEDIMIENTOSCONTRA') {
            model.classification.harmonizedRegulation = null;
          }
        }
      }
    }
  }

  public valueAttHarmonizedRegulationAYMADCBAM(model: any) {
    let someEntrepreneurs = model.contractingSystem.someEntrepreneurs;
    let visibleAtt = model?.context?.configurations?.isVisibleHarmonizedRegulation?.value;
    let isNewTenderBasedContract = model?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt === 1;
    let calculate = someEntrepreneurs && isNewTenderBasedContract && !visibleAtt;
    console.log('************************************************************');
    console.log('Foco valor estimado. Calculamos regulacion armonizada: ' + calculate);
    console.log('************************************************************');
    if (calculate) {
      let valorEstimado = model?.budget?.estimatedAmount ? model.budget.estimatedAmount : undefined;
      if (valorEstimado !== undefined) {
        valorEstimado = valorEstimado.toLocaleString('de-DE');
      }
      let tipoExpte = (model?.classification?.typeCode && model?.classification?.typeCode?.identifier) ?
        model?.classification?.typeCode.identifier : undefined;
      let tipoExpteIdentifier = undefined;
      if (tipoExpte !== undefined) {
        tipoExpteIdentifier = tipoExpte ? tipoExpte.substring(0, tipoExpte.indexOf('<>')) : undefined;
      }
      let articulo = model?.procurementProjectAM?.classification?.processJustificationNegotiated?.properties?.NUMARTICULO ?
        model?.procurementProjectAM?.classification?.processJustificationNegotiated?.properties?.NUMARTICULO : undefined;
      let apartado = model?.procurementProjectAM?.classification?.processJustificationNegotiated?.properties?.APARTADO ?
        model?.procurementProjectAM?.classification?.processJustificationNegotiated?.properties?.APARTADO : undefined;
      let justNeg = (articulo === undefined || apartado === undefined) ? '' : articulo + '.' + apartado;
      if (valorEstimado !== undefined && tipoExpte !== undefined && justNeg !== undefined) {
        let atribParams = 'VALORESTIMADO=' + valorEstimado
          + '&TIPO_EXPTE=' + tipoExpteIdentifier + '&JUSTNEG=' + justNeg;
        console.log('************************************************');
        console.log('parametros del atributo: ' + atribParams);
        this.subscribe(this.plycaService.getAttributeValue('REG_ARMONIZADA_AYMAD', atribParams),
          x => {
            if (x?.values[0]?.columns?.REG_ARMONIZADA?.value) {
              this.harmonizedRegulationAttributeAYMAD = x?.values[0]?.columns?.REG_ARMONIZADA?.value;
              console.log('************************************************');
              console.log('valor atributo: ' + this.harmonizedRegulationAttributeAYMAD);
              console.log('************************************************');
              if (this.harmonizedRegulationAttributeAYMAD === '1') {
                model.classification.harmonizedRegulation = true;
                // Se tiene que seleccionar en el combo la opcion de todas las empresas del AM
                model.breakdownLot.totalLots.companyToInvite_am = false;
                // Cargamos la tabla. En este caso el combo de empresas no está editable,
                // no se ejecuta el onChangeFunction. Cargamos la tabla aqui
                if (model?.breakdownLot?.totalLots?.companyToInvite_am !== undefined
                  && !model?.breakdownLot?.totalLots?.companyToInvite_am) {
                  if (model?.breakdownLot?.totalLots?.frameworkAgreementCompanies) {
                    model.breakdownLot.totalLots.companyToInvites = [];
                    model?.breakdownLot?.totalLots?.frameworkAgreementCompanies.forEach((company: CompanyDTO) => {
                      // generar objeto company
                      let companyToInvite = new CompanyToInviteDTO();
                      companyToInvite.company = company;
                      model.breakdownLot.totalLots.companyToInvites.push(companyToInvite);
                    });
                  }
                }
              } else if (this.harmonizedRegulationAttributeAYMAD === '0') {
                model.classification.harmonizedRegulation = false;
                // Se tiene que limpiar la opcion de todas las empresas del AM
                model.breakdownLot.totalLots.companyToInvite_am = undefined;
              } else {
                model.classification.harmonizedRegulation = undefined;
              }
            }
            console.log('****************************************************************************************************');
            console.log('valor MODELO model.classification.harmonizedRegulation: ' + model.classification.harmonizedRegulation);
            console.log('****************************************************************************************************');
            console.log('model.breakdownLot.totalLots.companyToInvite_am: ' + model.breakdownLot.totalLots.companyToInvite_am);
          },
          err => {
            console.log('************************************************');
            console.log('parametros del atributo REG_ARMONIZADA_AYMAD');
            console.log(err);
          });
      }
    }
  }

  public getVisibleLotSolvencyAccreditation(model: any): boolean {
    let openSimplifiedAbreviated =
      model.parent.type &&
      model.parent.type.identifier !== undefined &&
      model.parent.type.identifier === 'ASA<>PROCEDIMIENTOSCONTRA';

    let estimatedAmount =
      model.budget.estimatedAmount === undefined
        ? 0
        : model.budget.estimatedAmount;

    let limitAmount = model?.auxProperties !== undefined && model?.auxProperties['LIMITE_VE_FE'] !== undefined ?
      parseFloat(model?.auxProperties['LIMITE_VE_FE']) : 0;

    let visibilityByAmount = false;

    // Si está desglosado en lotes
    /*if (model.lotId !== 0) {
      let estimatedAmountFE = 0;
      let estimatedAmountPrevious = 0.0;

      // visibilityByAmount = estimatedAmount <= limitAmount
      // Valor estimado de la FE y Valor estimado del lotes
      estimatedAmountFE = model?.parent?.budget?.estimatedAmount;

      if (model.budget.estimatedAmountPrevious) {
        estimatedAmountPrevious = model.budget.estimatedAmountPrevious
      }
      // visibilityByAmount = estimatedAmount <= limitAmount
      // Valor estimado de la FE
      estimatedAmountFE = model?.parent?.budget?.estimatedAmount;

      if (estimatedAmountPrevious !== estimatedAmount) {
        estimatedAmountFE = estimatedAmountFE - estimatedAmountPrevious + estimatedAmount;
      }
      if (estimatedAmountFE <= limitAmount && estimatedAmount <= limitAmount) {
        visibilityByAmount = true;
      }

    } else {
      visibilityByAmount = estimatedAmount <= limitAmount
    }*/

    visibilityByAmount = estimatedAmount <= limitAmount;

    let visible = (!openSimplifiedAbreviated && visibilityByAmount);

    return visible;
  }

  public valueBudgetTotalTax_UnitPrice(model: any) {
    if (model?._parent?.budget?.manualTaxCalculation == undefined || (model?._parent?.budget?.manualTaxCalculation != undefined && model?._parent?.budget?.manualTaxCalculation)) {
      // Exento de IVA
      let noTax = (model.taxType &&
        model.taxType.identifier == '0<>TIPO_IMPUESTO');

      if (model.taxType && model.taxType.identifier) {
        let taxType = model.taxType.identifer;
        if (model.taxType.properties != undefined) {
          let percentage = model.taxType.properties.PORCENTAJE;
          // Exento de IVA
          if (noTax) {
            model.totalTaxes = 0;
          } else {
            if (percentage != undefined && percentage != 0 && model.amountExcludingTaxes != undefined && model.amountExcludingTaxes !== null) {
              //model.budget.totalTaxes = this.roundDecimals.bind(((model.budget.amountExcludingTaxes * percentage) / 100), 2);
              model.totalTaxes = ((model.amountExcludingTaxes * percentage) / 100);
            }
          }
        }
      } else {
        // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
        // model.budget.amountExcludingTaxes = 0;
        model.totalTaxes = 0;
        model.totalAmount = 0;
      }
    }
  }

  public setValueProvGuaranteeJustAM(model: any) {

    if (model.budget.provisionalGuaranteeAmount === undefined || model.budget.provisionalGuaranteeAmount === null) {
      model.budget.provisionalGuaranteeJust = '';
    }
  }

  public setValueProvGuarantee(model: any) {
    if (!model.budget.provisionalGuarantee) { //Si NO se ha marcado que hay garantia definitiva
      // Se limpian el resto de Campos
      model.budget.provisionalGuaranteePercentage = '';
      model.budget.provisionalGuaranteeAmount = '';
      model.budget.provisionalGuaranteeJust = '';
    } else {
      model.budget.provisionalGuaranteePercentage = 3;
      //this.procurementProjectValidations.valueProvisionalGuarantee(model);

      let budgetTypeEstimatedMax = model.budget.budgetType
        && model.budget.budgetType.identifier !== undefined && model.budget.budgetType.identifier === '2<>TIPOPRESUPUESTO';
      let budgetTypeDeterminatedMax = model.budget.budgetType
        && model.budget.budgetType.identifier !== undefined && model.budget.budgetType.identifier === '5<>TIPOPRESUPUESTO';

      let amountGuarantee = 0;
      let amountGaranteeProv = 0;

      if (model.budget.provisionalGuarantee) {
        if (budgetTypeEstimatedMax || budgetTypeDeterminatedMax) {
          // Importe Sin Iva
          if (model.budget && model.budget.amountExcludingTaxes !== undefined) {
            amountGuarantee = model.budget.amountExcludingTaxes;
          }
        } else {
          // Importe con Iva
          if (model.budget && model.budget.totalAmount !== undefined) {
            amountGuarantee = model.budget.totalAmount;
          }
        }
        if (amountGuarantee !== 0) {

          let digits = 2;
          let multiplier = Math.pow(10, digits);
          let valueBudget = ((amountGuarantee * model.budget.provisionalGuaranteePercentage) / 100);
          amountGaranteeProv = Math.round((valueBudget + Number.EPSILON) * multiplier) / multiplier;
          //amountGaranteeProv = this.roundDecimals(((amountGuarantee * model.budget.provisionalGuaranteePercentage) / 100), 2);
        }

        model.budget.provisionalGuaranteeAmount = amountGaranteeProv;
      } else {
        model.budget.provisionalGuaranteeAmount = 0;
      }

    }
  }

  public cleanTableUnitPrice(model: any) {
    if (model?.budget !== undefined && model?.budget?.budgetDetermination !== undefined && !model?.budget?.budgetDetermination) {
      model.budget.unitPrice = [];
    }

  }

  public isVisiblePaymentPrice(model: any) {
    let visible = model?.parent?.context?.configurations?.isVisiblePaymentPrice?.value;
    return visible;
  }

  public viewFormRevPrice(model: any) {

    let context = new LongTextDTOModal('', '', true
    );
    let config: DynamicDialogConfig = {
      header: 'Visualizar Fórmula',
      width: '50%',
      styleClass: 'formEdition'
    };
    context.label = 'Fórmula';
    let article = (model.formulaId && model.formulaId.properties) ? (model.formulaId.properties.DESC_FORMULA) : '';
    context.text = article;
    config['context'] = context;
    const ref = this.dialogService.open(LongTextEditorComponent, config);

    this.showDetailFormRevPrice = true;
  }

  public cleanTableFormRevPrice(model: any) {
    if (model?.priceRevision !== undefined && model?.priceRevision?.priceRevision !== undefined && model?.priceRevision?.priceRevision == 'NO') {
      model.priceRevision.priceRevisionFormula = [];
    }
  }

  // Pestaña II.j
  public evt_SubContractTermAuthorized(model: any) {

    if (model?.subContractTerm?.authorized != null && !model?.subContractTerm?.authorized) {
      // Si estan desglosados por lote
      if (model.parent && model.parent?.breakdownLot?.apportioned) {
        model.extLotTotalPercentageSubcontracted = null;
        model.extLotReservedPercentageSubcontracted = null;
      } else {
        model.subContractTerm.authorizedPercentage = null;
        model.subContractTerm.servicesTendererOblig = null;
      }
    }
  }
  public evt_DataOutSourcing(model: any) {
    if (model.dataOutsourcing !== null && model.dataOutsourcing) {
      model.subContractTerm.authorized = true;
    }
  }

  // Limpieza del desplegable de Contratos Reservados
  public cleanReservedContract(model: any) {
    // Se limpia el desplegable de Contratos Reservados
    if (!model.characteristicsContractObject.isReservedContract) {
      model.characteristicsContractObject.reservedContractType = {};
    }
  }

  public cleanReservedContractLot(model: any) {
    // Se limpia el desplegable de Contratos Reservados
    if (!model.extLotIsReservedContract) {
      model.extLotReservedContractType = {};
    }
  }

  // Establece el valor del check Se autoriza la subcontratación, cuando tiene lotes
  public setValueSubContractTermAuthorized(model: any) {
    let apportioned = model.parent?.breakdownLot?.apportioned;

    if (!model.parent?.exp_Subcontratacion_2023) {
      if (apportioned) {
        let isSubContractReserved = false;
        isSubContractReserved = model.extLotReservedContractType && model.extLotReservedContractType.properties &&
          model.extLotReservedContractType.properties.SUBCONTRATACION == 1
        // En el caso de que el lote sea reservado de subcontratacion
        if (model.extLotIsReservedContract && model.extLotReservedContractType != null && isSubContractReserved) {
          model.subContractTerm.authorized = true;
        } else {
          // Se limpia el campo de porcentaje de subcontratacion como reserva
          model.extLotReservedPercentageSubcontracted = null;
        }
        // Si es un expediente de la Rdl_14_2019 y esta seleccionado en el desplegable la opción de cesion de datos al subcontratista
        if (model.parent.exp_Rdl_14_2019 && model.dataOutsourcing != undefined && model.dataOutsourcing != null && model.dataOutsourcing) {
          model.subContractTerm.authorized = true;
        }

      }
    }
  }

  // Pestaña II.e
  // Metodo que realiza la carga por defecto de las condiciones especiales de ejecución
  public setSpecialExecutionCondition(model: any) {

    if (model.socClausesSpecialExecCond != null && model.socClausesSpecialExecCond) {

      // Por cada tipo de condiciones especiales de la ejecución, se inserta un registro en la tabla de Condiciones Especiales de la Ejecución
      this.subscribe(this.plycaService.getMasterDataValues('CS_DEF_CONDICION_ESP_EJEC', undefined, undefined, 'expansionSet:COMPLETE').pipe(
        tap(
          (data) => {
            if (data && data.content) {
              // Se filtran los tipos a mostrar y se ordenan por el campo orden
              let filteredSocClausesExecCond = data.content
                .filter((socExecCond) => (socExecCond.properties.ACTIVO === 1))
                .sort(
                  (a, b) =>
                    a.properties.ORDEN < b.properties.ORDEN
                      ? -1
                      : a.properties.ORDEN > b.properties.ORDEN
                        ? 1
                        : 0
                );
              if (filteredSocClausesExecCond) {
                let resultSocClausesExecCond = new Array<SpecialExecutionConditionDTO>();
                filteredSocClausesExecCond.forEach((sExecCond: MasterDataDTO) => {
                  // generar objeto company
                  let socExecCond = new SpecialExecutionConditionDTO();
                  socExecCond.type = sExecCond;
                  resultSocClausesExecCond.push(socExecCond);
                });
                model.specialExecutionCondition = resultSocClausesExecCond;
                this.formPlycaRef.updateView();
              }

            }
            (error: any) => this.plycaErrorHandler.showServerError(error);
          }

        )));
    } else {
      model.specialExecutionCondition = [];
      this.formPlycaRef.updateView();
    }
  }

  // Metodo que realiza la carga por defecto de los criterios de Adjudicación
  public setSocAwardCriteria(model: any) {

    if (model.socClausesAwardCriteria != null && model.socClausesAwardCriteria) {

      // Por cada tipo de condiciones especiales de la ejecución, se inserta un registro en la tabla de Condiciones Especiales de la Ejecución
      this.subscribe(this.plycaService.getMasterDataValues('CS_DEF_CRITERIOS_ADJ', undefined, undefined, 'expansionSet:COMPLETE').pipe(
        tap(
          (data) => {
            if (data && data.content) {
              // Se filtran los tipos a mostrar y se ordenan por el campo orden
              let filteredAwardCriteria = data.content
                .filter((socExecCond) => (socExecCond.properties.ACTIVO === 1))
                .sort(
                  (a, b) =>
                    a.properties.ORDEN < b.properties.ORDEN
                      ? -1
                      : a.properties.ORDEN > b.properties.ORDEN
                        ? 1
                        : 0
                );
              if (filteredAwardCriteria) {
                let resultSocAwardCriteria = new Array<SocClausesAwardCritDTO>();
                filteredAwardCriteria.forEach((sExecCond: MasterDataDTO) => {
                  // generar objeto company
                  let socExecCond = new SocClausesAwardCritDTO();
                  socExecCond.tenderCriteriaType = sExecCond;
                  resultSocAwardCriteria.push(socExecCond);
                });
                model.scAwardCriteria = resultSocAwardCriteria;
                this.formPlycaRef.updateView();
              }

            }
            (error: any) => this.plycaErrorHandler.showServerError(error);
          }

        )));
    } else {
      model.scAwardCriteria = [];
      this.formPlycaRef.updateView();
    }
  }

  // Ejecución de eventos que tiran de propiedades
  public editablePaymentPriceAYMAD(model: any) {
    let editable = false;
    if (model.auxProperties['EXP_HABILITAR_ABONOTOTALPRECIO'] !== undefined) {
      editable = model.auxProperties['EXP_HABILITAR_ABONOTOTALPRECIO'];
    }
    return editable;
  }

  //Metodo para calcular atributos, o propiedades, que sean necesarios para la carga del dto.
  public getAuxProperties(model: ProcurementProjectLotDTO): Observable<any[]> {
    let identifier = model?.parent?.identifier;
    model.auxProperties = {};

    let typeCode = model?.parent?.classification?.typeCode?.identifier;
    let isWorks = model?.parent?.classification.typeCode.identifier === '01<>TIPOEXPTE';
    let atribParamsVE_FE = 'EXPEDIENTE=' + typeCode.substring(0, 2);
    let atribParamsABONOTOTALPRECIO = 'EXPEDIENTE=' + identifier;
    let atribParamsEXPTE_FECHA_PARA_INSTRUC_1_16 = 'PROPUESTAID=' + identifier;

    console.log('**********************************************************************************');
    console.log('Calcuando atributos y propiedades para la propuesta: ' + identifier);
    return forkJoin([
      this.plycaService.getAttributeValue('EXP_HABILITAR_ABONOTOTALPRECIO', atribParamsABONOTOTALPRECIO)
        .pipe(catchError((error: any) => {
          console.error(error);
          return of(false)
        })),
      this.plycaService.getAttributeValue(
        'LIMITE_VE_FE', atribParamsVE_FE
      ).pipe(catchError((error: any) => {
        console.error(error);
        return of(false)
      })),
      this.plycaService.getAttributeValue(
        'EXPTE_FECHA_PARA_INSTRUC_1_16', atribParamsEXPTE_FECHA_PARA_INSTRUC_1_16
      ).pipe(catchError((error: any) => {
        console.error(error);
        return of(false)
      })),
      this.propertyService.getProperty('FECHA_INIVALIDEZ_PS', '')
        .pipe(catchError((error: any) => {
          console.log(error)
          return of(undefined)
        })),

      this.propertyService.getProperty('FECHA_FINVALIDEZ_PS', '')
        .pipe(catchError((error: any) => {
          console.log(error)
          return of(undefined)
        })),
    ]).pipe(
      tap((result: any[]) => {
        if (result) {
          let resultAbonoTotalPrecio = result[0];
          let resultLimiteVEFE = result[1];
          let resultEXPTE_FECHA_PARA_INSTRUC_1_16 = result[2];
          let startDatePS = result[3];
          let endDatePS = result[4];

          if (resultAbonoTotalPrecio) {
            if (resultAbonoTotalPrecio?.values[0]?.columns?.EXP_HABILITAR_ABONOTOTALPRECIO.value) {
              let value = resultAbonoTotalPrecio?.values[0]?.columns?.EXP_HABILITAR_ABONOTOTALPRECIO.value;
              model.auxProperties['EXP_HABILITAR_ABONOTOTALPRECIO'] = value;
              console.log('Valor del atributo EXP_HABILITAR_ABONOTOTALPRECIO: ' + value);
            }
          }
          if (resultLimiteVEFE) {
            let value = resultLimiteVEFE?.values[0]?.columns?.LIMITE_VE_FE.value;
            model.auxProperties['LIMITE_VE_FE'] = value;
            console.log('Valor del atributo LIMITE_VE_FE: ' + value);
          }
          if (resultEXPTE_FECHA_PARA_INSTRUC_1_16) {
            let value = resultEXPTE_FECHA_PARA_INSTRUC_1_16?.values[0]?.columns?.EXPTE_FECHA_PARA_INSTRUC_1_16.value;
            model.auxProperties['EXPTE_FECHA_PARA_INSTRUC_1_16'] = value;
            console.log('Valor del atributo EXPTE_FECHA_PARA_INSTRUC_1_16: ' + value);
          }
          if (startDatePS) {
            let value = startDatePS;
            model.auxProperties['FECHA_INIVALIDEZ_PS'] = value;
            console.log('Valor de la propiedad FECHA_INIVALIDEZ_PS: ' + value);
          }
          if (endDatePS) {
            let value = endDatePS;
            model.auxProperties['FECHA_FINVALIDEZ_PS'] = value;
            console.log('Valor de la propiedad FECHA_FINVALIDEZ_PS: ' + value);
          }
        }
      }
      )
    );
  }



  public static changeManualTaxCalculation(model): void {
    let updatedUnitPriceLine: UnitPriceDTO[] = [];
    let unitPriceLines = model.budget.unitPrice;
    // Importe Total
    unitPriceLines.forEach((unitPriceLine: any) => {

      let noTax = (unitPriceLine.taxType &&
        unitPriceLine.taxType.identifier == '0<>TIPO_IMPUESTO');

      if (unitPriceLine.taxType && unitPriceLine.taxType.identifier) {
        if (unitPriceLine.taxType.properties != undefined) {
          let percentage = unitPriceLine.taxType.properties.PORCENTAJE;
          // Exento de IVA
          if (noTax) {
            unitPriceLine.totalTaxes = 0;
          } else {
            if (percentage != undefined && percentage != 0 && unitPriceLine.amountExcludingTaxes != undefined && unitPriceLine.amountExcludingTaxes !== null) {
              //model.budget.totalTaxes = this.roundDecimals.bind(((model.budget.amountExcludingTaxes * percentage) / 100), 2);
              unitPriceLine.totalTaxes = ((unitPriceLine.amountExcludingTaxes * percentage) / 100);
            }
          }
        }
        let total = (unitPriceLine.amountExcludingTaxes || 0) + (unitPriceLine.totalTaxes);
        let digits: number = 2;
        let multiplier = Math.pow(10, digits);
        unitPriceLine.totalAmount = ((total + Number.EPSILON) * multiplier) / multiplier;
      } else {
        // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
        // model.budget.amountExcludingTaxes = 0;
        unitPriceLine.totalTaxes = 0;
        unitPriceLine.totalAmount = 0;
      }
      updatedUnitPriceLine.push(unitPriceLine);
    });
    model.budget.unitPrice = [...updatedUnitPriceLine];
  }

  public evtChangeManualTaxCalculation(model: any, evt: any): void {
    // Evento de fraccionamiento en lotes
    if (evt.newValue != null && evt.oldValue != null && model?.budget?.unitPrice && model.budget.unitPrice.length > 0) {
      if (model.identifier != undefined && model.identifier != null && evt.newValue && !evt.oldValue) {
        this.confirmationService.confirm({
          message: 'Se va a proceder a recalcular la cuantía del IVA.... TERCERO',
          acceptLabel: 'Aceptar',
          rejectVisible: true,
          accept: () => {
            procurementProjectAYMADComponent.changeManualTaxCalculation(model);
            /*let updatedUnitPriceLine: UnitPriceDTO[] = [];
            let unitPriceLines = model.budget.unitPrice;
            // Importe Total
            unitPriceLines.forEach((unitPriceLine: any) => {

              let noTax = (unitPriceLine.taxType &&
                unitPriceLine.taxType.identifier == '0<>TIPO_IMPUESTO');

              if (unitPriceLine.taxType && unitPriceLine.taxType.identifier) {
                if (unitPriceLine.taxType.properties != undefined) {
                  let percentage = unitPriceLine.taxType.properties.PORCENTAJE;
                  // Exento de IVA
                  if (noTax) {
                    unitPriceLine.totalTaxes = 0;
                  } else {
                    if (percentage != undefined && percentage != 0 && unitPriceLine.amountExcludingTaxes != undefined && unitPriceLine.amountExcludingTaxes !== null) {
                      //model.budget.totalTaxes = this.roundDecimals.bind(((model.budget.amountExcludingTaxes * percentage) / 100), 2);
                      unitPriceLine.totalTaxes = ((unitPriceLine.amountExcludingTaxes * percentage) / 100);
                    }
                  }
                }
                let total = (unitPriceLine.amountExcludingTaxes || 0) + (unitPriceLine.totalTaxes);
                let digits: number = 2;
                let multiplier = Math.pow(10, digits);
                unitPriceLine.totalAmount = ((total + Number.EPSILON) * multiplier) / multiplier;
              } else {
                // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
                // model.budget.amountExcludingTaxes = 0;
                unitPriceLine.totalTaxes = 0;
                unitPriceLine.totalAmount = 0;
              }
              updatedUnitPriceLine.push(unitPriceLine);
            });
            model.budget.unitPrice = [...updatedUnitPriceLine];*/
            this.formPlycaRef.updateView();
          },
        });
      }
    }
  }




  public changeApportioned(model: any, evt: any): void {
    // Evento de fraccionamiento en lotes
    // En el caso de que sea nulo ya que puede ser que se haya pulsado el aspa del desplegable

    if ((evt.newValue == null) || (evt.newValue != null && evt.oldValue != null)) {
      if ((evt.newValue == null) || (!evt.newValue && evt.oldValue)) {
        if (model.breakdownLot?.lots != null && model.breakdownLot?.lots.length > 0) {
          // Se deja el valor que tenía antes el desplegable, no se puede modificar a "SI", hasta que elimine todos lotes
          setTimeout(() => {
            model.breakdownLot.apportioned = true;
            if (model.breakdownLot && model.breakdownLot.apportioned && model.breakdownLot.tenderAllLots) {
              model.breakdownLot.numLicitableLots = null;
            }
            this.formPlycaRef.updateView();
          }, 500);

          this.confirmationService.confirm({
            message: '(I.A) Si se modifica el expediente para que "No" esté fraccionado en lotes o se limpia el valor del desplegable, es necesario eliminar los registros previamente introducidos en la tabla lotes (I.b)',
            acceptLabel: 'Aceptar',
            rejectVisible: false,
            accept: () => {
            },
          });
        }
      } else if (model.identifier != undefined && model.identifier != null && evt.newValue && !evt.oldValue) {
        this.confirmationService.confirm({
          message: '(I.A) Si el valor del desplegable "Fraccionado en lotes", se modifica a "Sí", al pulsar el botón de "Aceptar", se eliminarán los datos introducidos en el Paso II',
          acceptLabel: 'Aceptar',
          rejectVisible: false,
          accept: () => {
          },
        });
      }
    }
    if (model.breakdownLot && model.breakdownLot.apportioned && model.breakdownLot.tenderAllLots) {
      model.breakdownLot.numLicitableLots = null;
    }
  }

  // Funciones que se utilizan para los AM
  public setPlannedTenderBasedFrameworkAgreementAdapt_AM(model: any) {
    let someEntrepreneurs = false;
    if (model.contractingSystem?.someEntrepreneurs != undefined && model.contractingSystem?.someEntrepreneurs != null && model.contractingSystem?.someEntrepreneurs) {
      someEntrepreneurs = true;
    }

    if (someEntrepreneurs) {
      if (model.contractingSystem?.fameworkAgreementTerm_aymad == undefined || model.contractingSystem?.fameworkAgreementTerm_aymad == null) {
        model.contractingSystem.plannedTenderBasedFrameworkAgreementAdapt = null;
      }
      if (model.contractingSystem?.fameworkAgreementTerm_aymad != undefined && model.contractingSystem?.fameworkAgreementTerm_aymad != null && model.contractingSystem?.fameworkAgreementTerm_aymad === false) {
        model.contractingSystem.plannedTenderBasedFrameworkAgreementAdapt = 1;
      }
    }


  }


  public calculateBudgetsUnitPriceCSDA(model: any) {
    let taxType: MasterDataDTO; // Tipo de Impuesto: PRESUPMAXGAS.TIPO_IVA
    let taxTypesSomeTaxes: MasterDataDTO; // Tipo de Impuesto: PRESUPMAXGAS.TIPO_IVA

    let sumTotalAmount: number; // Importe del Precio Unitario:PRESUPMAXGAS.PRESUNITARIO_CONIVA
    let sumAmountExcludingTaxes: number; // Importe sin IVA: PRESUPMAXGAS.PRESUNITARIO_SINIVA
    let sumTotalTaxes: number;
    let amount: number; // Cantidad: Número de unidades
    let lTaxType: String[] = []; // Tipos de IVA

    sumTotalAmount = 0;
    sumAmountExcludingTaxes = 0;
    sumTotalTaxes = 0;
    amount = 0;

    taxTypesSomeTaxes = new MasterDataDTO('998', 'TIPO_IMPUESTO');
    taxTypesSomeTaxes.description = 'Varios Tipos';

    // Se recuperan los precios Unitarios de Base de Datos, ya no estan por pantalla
    let params;
    params = {
      'parentDoc.division.project.identifier': this.dossierId,
      'parentDoc.documentClass.identifier': '00002',
      'parentDoc.orderNumber': 0 + '',
      'lot.lotId': 0
    }

    this.subscribe(
      this.plycaService.query<any>(
        this.configuration.UNITPRICES_SERVICE_URL, params
      ).pipe(
        finalize(() => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        })
      ),
      results => {
        if (results && results.content) {
          model.budget.unitPrice = results.content;
          // Si hay Precios Unitarios
          if (model.budget && model.budget.unitPrice && model.budget.unitPrice.length > 0) {
            let UnitPriceLines: UnitPriceDTO[] = model.budget.unitPrice
            // Importe Total
            UnitPriceLines.forEach((unitPriceLine: UnitPriceDTO) => {
              if (unitPriceLine.amount != undefined) {
                amount = unitPriceLine.amount;
              }
              if (unitPriceLine.amountExcludingTaxes != undefined) {
                sumAmountExcludingTaxes += (unitPriceLine.amountExcludingTaxes * amount);
              }
              if (unitPriceLine.totalTaxes != undefined) {
                sumTotalTaxes += (unitPriceLine.totalTaxes * amount);
              }
              if (unitPriceLine.totalAmount != undefined) {
                sumTotalAmount += (unitPriceLine.totalAmount * amount);
              }
              // Tipo de IVA
              if (unitPriceLine.taxType != undefined && unitPriceLine.taxType.identifier != undefined) {
                taxType = unitPriceLine.taxType;
                if (lTaxType != undefined && !lTaxType.includes(taxType.identifier))
                  lTaxType.push(taxType.identifier);
              }

            });


            model.budget.amountExcludingTaxes = this.redondear(sumAmountExcludingTaxes, 2);
            //model.budget.amountExcludingTaxes = this.roundDecimals(sumAmountExcludingTaxes, 2);
            model.budget.taxType = taxType;

            // Se establece el tipo de IVA
            // Si tienen el mismo tipo de iva todos los lotes y es distinto de Varios se volcará en el campo Tipo Impositivo
            if (lTaxType != undefined && lTaxType.length > 0) {
              if (lTaxType.length == 1) {
                model.budget.taxType = taxType;
              } else {
                model.budget.taxType = taxTypesSomeTaxes
              }
            }
            // Se establece el tipo Impositivo
            if (model.budget.taxType) {
              if (model.budget.taxType.identifer == '999<>TIPO_IMPUESTO') {
                model.budget.taxRate = '';
              } else {
                model.budget.taxRate = model.budget.taxType.description;
              }
            }
            model.budget.totalTaxes = this.redondear(sumTotalTaxes, 2);
            //model.budget.totalTaxes = this.roundDecimals(sumTotalTaxes, 2);
            model.budget.totalAmount = this.redondear(sumTotalAmount, 2);
            //model.budget.totalAmount = this.roundDecimals(sumTotalAmount, 2);
            this.formPlycaRef.updateView();
            this.waitService.cancelWaiting();

          }


        } else {
          this.uiService.showMessage(
            'No es posible realizar el "Volcado de Importes de Precios Unitarios", si previamente no han sido dados de alta (Botón Precios Unitarios)"',
            'Información'
          );
          this.waitService.cancelWaiting();
        }

      },
      error => {
        this.waitService.cancelWaiting();
        this.plycaErrorHandler.showServerError(error)
      });
  }

  public calculateBudgetsUnitPrice(model: any) {

    let taxType: MasterDataDTO; // Tipo de Impuesto: PRESUPMAXGAS.TIPO_IVA
    let taxTypesSomeTaxes: MasterDataDTO; // Tipo de Impuesto: PRESUPMAXGAS.TIPO_IVA

    let sumTotalAmount: number; // Importe del Precio Unitario:PRESUPMAXGAS.PRESUNITARIO_CONIVA
    let sumAmountExcludingTaxes: number; // Importe sin IVA: PRESUPMAXGAS.PRESUNITARIO_SINIVA
    let sumTotalTaxes: number;
    let amount: number; // Cantidad: Número de unidades
    let lTaxType: String[] = []; // Tipos de IVA

    sumTotalAmount = 0;
    sumAmountExcludingTaxes = 0;
    sumTotalTaxes = 0;
    amount = 0;

    taxTypesSomeTaxes = new MasterDataDTO('998', 'TIPO_IMPUESTO');
    taxTypesSomeTaxes.description = 'Varios Tipos';

    // Se recuperan los precios Unitarios de Base de Datos, ya no estan por pantalla
    let params;
    params = {
      'parentDoc.division.project.identifier': this.lot.parent.identifier,
      'parentDoc.documentClass.identifier': '00002',
      'parentDoc.orderNumber': 0 + '',
      'lot.lotId': this.lot.lotId
    }

    this.subscribe(
      this.plycaService.query<any>(
        this.configuration.UNITPRICES_SERVICE_URL, params
      ).pipe(
        finalize(() => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        })
      ),
      results => {
        if (results && results.content) {
          model.budget.unitPrice = results.content;
          // Si hay Precios Unitarios
          if (model.budget && model.budget.unitPrice && model.budget.unitPrice.length > 0) {
            let UnitPriceLines: UnitPriceDTO[] = model.budget.unitPrice
            // Importe Total
            UnitPriceLines.forEach((unitPriceLine: UnitPriceDTO) => {
              if (unitPriceLine.amount != undefined) {
                amount = unitPriceLine.amount;
              }
              if (unitPriceLine.amountExcludingTaxes != undefined) {
                sumAmountExcludingTaxes += (unitPriceLine.amountExcludingTaxes * amount);
              }
              if (unitPriceLine.totalTaxes != undefined) {
                sumTotalTaxes += (unitPriceLine.totalTaxes * amount);
              }
              if (unitPriceLine.totalAmount != undefined) {
                sumTotalAmount += (unitPriceLine.totalAmount * amount);
              }
              // Tipo de IVA
              if (unitPriceLine.taxType != undefined && unitPriceLine.taxType.identifier != undefined) {
                taxType = unitPriceLine.taxType;
                if (lTaxType != undefined && !lTaxType.includes(taxType.identifier))
                  lTaxType.push(taxType.identifier);
              }

            });


            model.budget.amountExcludingTaxes = this.redondear(sumAmountExcludingTaxes, 2);
            // model.budget.amountExcludingTaxes = this.roundDecimals(sumAmountExcludingTaxes, 2);
            model.budget.taxType = taxType;

            // Se establece el tipo de IVA
            // Si tienen el mismo tipo de iva todos los lotes y es distinto de Varios se volcará en el campo Tipo Impositivo
            if (lTaxType != undefined && lTaxType.length > 0) {
              if (lTaxType.length == 1) {
                model.budget.taxType = taxType;
              } else {
                model.budget.taxType = taxTypesSomeTaxes
              }
            }
            // Se establece el tipo Impositivo
            if (model.budget.taxType) {
              if (model.budget.taxType.identifer == '999<>TIPO_IMPUESTO') {
                model.budget.taxRate = '';
              } else {
                model.budget.taxRate = model.budget.taxType.description;
              }
            }
            model.budget.totalTaxes = this.redondear(sumTotalTaxes, 2);
            model.budget.totalAmount = this.redondear(sumTotalAmount, 2);
            // model.budget.totalTaxes = this.roundDecimals(sumTotalTaxes, 2);
            // model.budget.totalAmount = this.roundDecimals(sumTotalAmount, 2);
            this.formPlycaRef.updateView();
            this.waitService.cancelWaiting();

          }


        } else {
          this.uiService.showMessage(
            'No es posible realizar el "Volcado de Importes de Precios Unitarios", si previamente no han sido dados de alta (Botón Precios Unitarios)"',
            'Información'
          );
          this.waitService.cancelWaiting();
        }

      },
      error => {
        this.waitService.cancelWaiting();
        this.plycaErrorHandler.showServerError(error)
      });
  }

  redondear(valor: number, decimales: number): number {
    const factor = Math.pow(10, decimales);
    const valorMultiplicado = valor * factor;
    const valorRedondeado = Math.round(valorMultiplicado);
    return valorRedondeado / factor;
  }

  public roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals == 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  public viewArticle(model: any) {

    let context = new LongTextDTOModal('', '', true
    );
    let config: DynamicDialogConfig = {
      header: 'Visualizar Artículo',
      width: '50%',
      styleClass: 'formEdition'
    };
    context.label = 'Artículo';
    let article = (model.technicalFinancialEvaluation && model.technicalFinancialEvaluation.properties) ? ((model.technicalFinancialEvaluation.properties.ARTICULO) + ' ' + (model.technicalFinancialEvaluation.properties.DESCRIPCION)) : '';
    context.text = article;
    config['context'] = context;
    const ref = this.dialogService.open(LongTextEditorComponent, config);

  }

  public importUnitPrice(model: any) {
    let confirmMessage = '';
    if (model?.budget?.unitPrice && model?.budget?.unitPrice.length > 0) {
      confirmMessage = 'REEMPLAZAR eliminará los registros existentes en la tabla de precios unitarios y añadirá los registros del archivo Excel que seleccione a continuación';
    } else {
      confirmMessage = 'AÑADIR cargará los registros del archivo Excel seleccionado';
    }
    this.uiService.showConfirmMessage({
      message: confirmMessage,
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscribe(this.plycaService.getAction('IMPORT_UNITPRICE_FROM_EXCEL'), (datos: any) => {
          if (datos && datos.content) {
            let actionDefinition: ActionDefinitionDTO = datos.content[0];

            if (actionDefinition && actionDefinition.executableAction) {
              let action = actionDefinition.executableAction;
              action.parameters = action.parameters.filter(
                (param) => param.name !== 'TARGET'
              );
              let pLot = ProcurementProjectLotDTO.patchDTO(new ProcurementProjectLotDTO());
              //pLot.budget = new LotBudgetDTO;
              //pLot.parent = new ProcurementProjectDTO;
              pLot.lotId = model.lotId;
              pLot.lotNumber = model.lotNumber;
              pLot.parent = model.parent;
              pLot.budget.unitPrice = model.budget.unitPrice;
              pLot = JSON.parse(
                JSON.stringify(pLot, (k, v) => (k === '_parent' ? undefined : v))
              );
              action.target = pLot;
              action.target.class = 'com.nexusit.plyca.api.userAPI.v1.procurementproject.lot.ProcurementProjectLotDTO';

              let config: DynamicDialogConfig = {
                header: actionDefinition.executableAction.name,
                width: '70%',
                styleClass: 'actionStyle',
              };
              config['action'] = action;
              config['dto'] = actionDefinition.executableAction.target;
              config['runAction'] = true;

              const ref = this.dialogService.open(ActionsProcessComponent, config);
              this.subscribe(ref.onClose, (result: any) => {
                if (result && result.length) {
                  model.budget.unitPrice = [...result];
                  if (model.budget?.manualTaxCalculation != undefined && model.budget?.manualTaxCalculation) {
                    procurementProjectAYMADComponent.changeManualTaxCalculation(model);
                    /*let updatedUnitPriceLine: UnitPriceDTO[] = [];
                    let unitPriceLines = [...model.budget.unitPrice];
                    // Importe Total
                    unitPriceLines.forEach((unitPriceLine: any) => {

                      let noTax = (unitPriceLine.taxType &&
                        unitPriceLine.taxType.identifier == '0<>TIPO_IMPUESTO');

                      if (unitPriceLine.taxType && unitPriceLine.taxType.identifier) {
                        if (unitPriceLine.taxType.properties != undefined) {
                          let percentage = unitPriceLine.taxType.properties.PORCENTAJE;
                          // Exento de IVA
                          if (noTax) {
                            unitPriceLine.totalTaxes = 0;
                          } else {
                            if (percentage != undefined && percentage != 0 && unitPriceLine.amountExcludingTaxes != undefined && unitPriceLine.amountExcludingTaxes !== null) {
                              //model.budget.totalTaxes = this.roundDecimals.bind(((model.budget.amountExcludingTaxes * percentage) / 100), 2);
                              unitPriceLine.totalTaxes = ((unitPriceLine.amountExcludingTaxes * percentage) / 100);
                            }
                          }
                        }
                        let total = (unitPriceLine.amountExcludingTaxes || 0) + (unitPriceLine.totalTaxes);
                        let digits: number = 2;
                        let multiplier = Math.pow(10, digits);
                        unitPriceLine.totalAmount = ((total + Number.EPSILON) * multiplier) / multiplier;
                      } else {
                        // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
                        // model.budget.amountExcludingTaxes = 0;
                        unitPriceLine.totalTaxes = 0;
                        unitPriceLine.totalAmount = 0;
                      }
                      updatedUnitPriceLine.push(unitPriceLine);
                    });
                    model.budget.unitPrice = [...updatedUnitPriceLine];*/
                  }
                  this.formPlycaRef.markAsDirty();
                  this.formPlycaRef.updateView();
                }
              });
            }
          }
        });

      },
      reject: () => {
        console.log('NO SE IMPORTAN LAS EMPRESAS A INVITAR');
      }
    });
  }

  public exporAlltUnitPrice() {
    let model = this.dossier;
    this.subscribe(this.plycaService.getAction('EXPORT_UNITPRICE_TO_EXCEL'), (datos: any) => {
      if (datos && datos.content) {
        let actionDefinition: ActionDefinitionDTO = datos.content[0];

        if (actionDefinition && actionDefinition.executableAction) {
          let action = actionDefinition.executableAction;
          action.parameters = action.parameters.filter(
            (param) => param.name !== 'TARGET'
          );
          let procurementProject = ProcurementProjectDTO.patchDTO(new ProcurementProjectDTO());
          procurementProject.breakdownLot.lots = model.breakdownLot.lots;
          procurementProject.classification = model.classification;
          model = JSON.parse(
            JSON.stringify(model, (k, v) => (k === '_parent' ? undefined : v))
          );
          action.target = model;
          action.target.class = 'com.nexusit.plyca.api.userAPI.v1.procurementproject.ProcurementProjectDTO'

          let config: DynamicDialogConfig = {
            header: actionDefinition.executableAction.name,
            width: '70%',
            styleClass: 'actionStyle',
          };
          config['action'] = action;
          config['dto'] = actionDefinition.executableAction.target;
          config['runAction'] = true;

          const ref = this.dialogService.open(ActionsProcessComponent, config);
          this.subscribe(ref.onClose, (result: any) => {
            if (result && result.length) {
              //console.log('Importados precios unitarios' + model.budget.unitPrice.length);
            }
          });
        }
      }
    });
  }

  public exportUnitPrice(model: any) {
    this.subscribe(this.plycaService.getAction('EXPORT_UNITPRICE_TO_EXCEL'), (datos: any) => {
      if (datos && datos.content) {
        let actionDefinition: ActionDefinitionDTO = datos.content[0];

        if (actionDefinition && actionDefinition.executableAction) {
          let action = actionDefinition.executableAction;
          action.parameters = action.parameters.filter(
            (param) => param.name !== 'TARGET'
          );
          let pLot = ProcurementProjectLotDTO.patchDTO(new ProcurementProjectLotDTO());
          //pLot.budget = new LotBudgetDTO;
          //pLot.parent = new ProcurementProjectDTO;
          pLot.lotId = model.lotId;
          //action.parameters.find((a) => a.name == 'LOTE').value = model.lotNumber;
          pLot.lotNumber = model.lotNumber;
          pLot.parent = model.parent;
          pLot.budget.unitPrice = model.budget.unitPrice;
          pLot = JSON.parse(
            JSON.stringify(pLot, (k, v) => (k === '_parent' ? undefined : v))
          );
          action.target = pLot;
          action.target.class = 'com.nexusit.plyca.api.userAPI.v1.procurementproject.lot.ProcurementProjectLotDTO'

          let config: DynamicDialogConfig = {
            header: actionDefinition.executableAction.name,
            width: '70%',
            styleClass: 'actionStyle',
          };
          config['action'] = action;
          config['dto'] = actionDefinition.executableAction.target;
          config['runAction'] = true;

          const ref = this.dialogService.open(ActionsProcessComponent, config);
          this.subscribe(ref.onClose, (result: any) => {
            if (result && result.length) {
              console.log('Importados precios unitarios' + model.budget.unitPrice.length);
            }
          });
        }
      }
    });
  }

  public valueUTDays(model: any) {

    let isWorkMinorTerm = false;
    isWorkMinorTerm = model?.worksData?.warningEndingWorksTerm && model?.worksData.warningEndingWorksTerm === 1;

    if (!isWorkMinorTerm) {
      model.worksData.utOtherEndingWorksTerm = {};
      model.worksData.utContractingUnitTerm = {};
      model.worksData.utInterventionTerm = {};
    } else {
      model.worksData.utOtherEndingWorksTerm = {};
      model.worksData.utOtherEndingWorksTerm.identifier = '1<>UNIDADTIEMPO';
      model.worksData.utOtherEndingWorksTerm.description = 'Días';

      model.worksData.utContractingUnitTerm = {};
      model.worksData.utContractingUnitTerm.identifier = '1<>UNIDADTIEMPO';
      model.worksData.utContractingUnitTerm.description = 'Días';

      model.worksData.utInterventionTerm = {};
      model.worksData.utInterventionTerm.identifier = '1<>UNIDADTIEMPO';
      model.worksData.utInterventionTerm.description = 'Días';
    }
  }


  /*removeLotMessage(model: any, index: any, lot: ProcurementProjectLotDTO) {
    let identifier = lot.identifier;

    // Si existe desglose de lote

    if (lot) {  // Array<BudgetAccountLineInvoiceAssociationDTO>

      let budgetAccountLineInvoiceAssociatesFiltered = model.ui.budgetAccountLineInvoiceAssociates.filter(
        action => action && action.budgetAccountLine && action.budgetAccountLine.identifier === identifier
      );

      if (budgetAccountLineInvoiceAssociatesFiltered.length > 0) {
        let budgetAccountLineLabel = '';
        let message = '<ul>';
        for (let budgetAccountLineInvoiceAssociate of budgetAccountLineInvoiceAssociatesFiltered) {

          let numberInvocie = budgetAccountLineInvoiceAssociate.invoice.number;
          let serialNumberInvocie = budgetAccountLineInvoiceAssociate.invoice.serialNumber;

          let taxType = budgetAccountLineInvoiceAssociate.invoiceDetailLine.budget.taxType.description;

          budgetAccountLineLabel = budgetAccountLineInvoiceAssociate.budgetAccountLine.label;

          message += '<li>Factura: ' + numberInvocie + ' ' + serialNumberInvocie + ' ' + taxType + '</li>';
        }
        message += '</ul>';
        this.uiService.showMessage('La partida, ' + budgetAccountLineLabel + ', no se puede borrar porque está asociada a las siguientes facturas:' + message, 'Validación', 'errorStyle');
        return false;
      }
    }
    return true;
  }*/

  public openUnitPricesEditorCSDA() {
    let procurementprojectLot = lodash.cloneDeep(this.dossier.breakdownLot.totalLots);
    procurementprojectLot.parent = lodash.cloneDeep(this.dossier);
    procurementprojectLot.parent.breakdownLot.totalLots = undefined;

    let titulo = 'Precios unitarios';

    let typeCode = (this.dossier?.classification?.typeCode && this.dossier?.classification?.typeCode?.identifier) ?
      this.dossier?.classification?.typeCode.identifier : undefined;
    let isServices = typeCode !== undefined && this.dossier?.classification.typeCode.identifier === '04<>TIPOEXPTE';
    let isGoods = typeCode !== undefined && this.dossier?.classification.typeCode.identifier === '02<>TIPOEXPTE';

    if (isServices) {
      titulo = 'Servicios requeridos';
    }
    if (isGoods) {
      titulo = 'Suministros a adquirir';
    }

    let config: DynamicDialogConfig = {
      header: titulo,
      width: '99%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    context['readonly'] = this.readonly;
    context['procurementprojectLot'] = procurementprojectLot;
    context['procurementprojectAM'] = false;
    config['context'] = context;
    if (this.task) {
      config.data = {
        task: this.task
      };
    }
    this.waitService.startWaiting();
    this.subscribe(this.dialogService.open(UnitPricesListComponent, config).onClose,
      (materialSaved: boolean) => {

      },
      (error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);

      });
  }

  public confirmOpenUnitPricesEditorCSDA() {
    /*let procurementprojectLot = this.dossier.breakdownLot.totalLots;
    procurementprojectLot.parent = this.dossier;
    procurementprojectLot.parent.breakdownLot.totalLots = undefined;*/

    if (this.dossierId === undefined) {
      this.uiService.showConfirmMessage({
        message: 'Para gestionar precios unitarios, es necesario que la ficha se grabe previamente. Pulse aceptar para grabar',
        header: 'Confirmacion',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.subscribe(this.saveObservable().pipe(finalize(() => {
            this.waitService.cancelWaiting();
            this.openUnitPricesEditorCSDA();
          })))
        },
        reject: () => {
          console.log('No hace nada...');
        }
      });
    } else {
      this.openUnitPricesEditorCSDA();
    }
  }



  public openUnitPricesEditor(procurementprojectLot?: ProcurementProjectLotDTO) {
    let titulo = 'Edición de precios unitarios del expediente';
    if (procurementprojectLot.lotId !== 0) {
      titulo = 'Edición de precios unitarios: Lote ' + procurementprojectLot.lotNumber;
    }

    let config: DynamicDialogConfig = {
      header: titulo,
      width: '99%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    context['readonly'] = this.readonly;
    context['procurementprojectLot'] = procurementprojectLot;
    context['procurementprojectAM'] = this.dossier?.classification?.complementarySystem?.identifier == 'AM<>SISTCOMPLEMENTARIO';
    config['context'] = context;
    if (this.task) {
      config.data = {
        task: this.task
      };
    }
    this.waitService.startWaiting();
    this.subscribe(this.dialogService.open(UnitPricesListComponent, config).onClose,
      (materialSaved: boolean) => {

      },
      (error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);

      });
  }

  public evtChangeValueFrameworkAgreementAwardType(model: any, evt: any) {

    if (evt.newValue && evt.oldValue && evt.newValue !== evt.oldValue) {
      // Código a ejecutar si la condición se cumple
      if (model.contractingSystem.frameworkAgreementAwardType != null && model.contractingSystem.frameworkAgreementAwardType === 'U') {
        model.contractingSystem.onlyEntrepreneur = true;
        model.contractingSystem.someEntrepreneurs = null;
      } else {
        model.contractingSystem.someEntrepreneurs = true;
        model.contractingSystem.onlyEntrepreneur = null;
      }
    }
  }



  // A partir de aqui estas funciones no se utilizan, en una siguiente versión se hará uso de ellas
  //////////////////////////////////////////////////////
  public roundHalfEven(value: number, decimalPlaces: number): number {

    /*El redondeo ROUND_HALF_EVEN redondea un número al número par más cercano cuando se encuentra exactamente a la mitad entre dos enteros. Por ejemplo:
      2.5 se redondea a 2 (par).
      3.5 se redondea a 4 (par).
    */
    const factor = Math.pow(10, decimalPlaces);
    const n = value * factor;

    // Redondear a la mitad del valor más cercano
    const rounded = Math.round(n);

    // Verificar si el número está exactamente en la mitad
    if (Math.abs(n - Math.floor(n) - 0.5) < Number.EPSILON) {
      // Si la mitad, redondear al número par más cercano
      return (rounded % 2 === 0) ? rounded / factor : (rounded - 1) / factor;
    }

    return rounded / factor;
  }

  // Apertura de documento de FE
  /* openDocument(model: any) {
    //this.goToDossierInfo(model);
    this.openDocumentViewer(model);
  }

  goToDossierInfo(model: any) {
    this.router.navigate(['/dossierInfo/' + model.identifier], {
      queryParams: { component: 'DOCUMENTS' }
    });
  }

  openDocumentViewer(model: any) {
    if (model?.fichProcurementProject) {
      let config: DynamicDialogConfig = {

        header: 'Ficha de Propuesta Expediente',
        width: '97%',
        styleClass: 'searchStyle'
      };

      config.data = {
        'id': model.fichProcurementProject.documentClass.identifier

      }
      let modal = this.dialogService.open(documentViewerComponent, config);
      this.subscribe(modal.onClose);
    }
  }*/

}
